export const sponsors = [
  // PRINCIPALES (relevancia 10)
  {
    id: 1,
    payed : true,
    nombre: "Holcim",
    enlace: "https://www.holcim.com.ec/",
    categoria: "principales",
    subcategoria: ["bricks", "blocks", "hormigon", "estructuras"],
    descripcion: "Holcim es uno de los principales proveedores mundiales de cemento y agregados (piedra triturada, grava y arena), así como de otras actividades, como concreto premezclado y asfalto, incluidos los servicios.",
    svgContent: `
      <path d="M2500 3184 c-147 -22 -240 -49 -335 -97 -206 -103 -352 -263 -435
      -478 -48 -125 -62 -228 -67 -511 l-6 -268 322 0 c176 0 324 -1 329 -2 4 -2 9
      155 12 347 l5 350 255 0 255 0 3 -568 2 -568 23 7 c12 3 54 21 94 39 265 121
      450 350 519 640 23 97 23 286 0 390 -61 274 -242 506 -491 626 -143 69 -362
      111 -485 93z"/>
      <path d="M6720 2234 c-14 -2 -52 -9 -85 -15 -137 -25 -285 -101 -392 -202
      -291 -274 -325 -744 -76 -1055 105 -130 256 -227 428 -273 113 -30 316 -30
      430 0 290 77 503 286 576 566 27 102 29 279 6 377 -70 288 -275 496 -569 578
      -71 19 -262 34 -318 24z m244 -407 c65 -30 136 -93 169 -150 46 -80 60 -140
      55 -250 -3 -88 -8 -111 -34 -167 -39 -83 -101 -145 -184 -184 -58 -27 -75 -30
      -155 -30 -76 0 -99 4 -147 26 -165 76 -258 259 -229 448 26 169 139 299 284
      330 71 15 180 4 241 -23z"/>
      <path d="M10029 2230 c-324 -42 -593 -284 -664 -600 -24 -107 -22 -275 5 -381
      105 -423 531 -668 980 -562 95 22 236 93 304 152 60 53 146 149 146 163 0 6
      -227 172 -287 208 -20 13 -26 9 -82 -42 -90 -84 -155 -112 -266 -116 -73 -3
      -101 0 -147 18 -164 61 -261 254 -230 455 20 129 89 232 194 291 50 27 60 29
      163 29 100 0 115 -3 167 -28 31 -15 82 -53 112 -83 l56 -55 155 118 c84 65
      154 124 154 131 1 20 -151 164 -212 201 -149 88 -355 126 -548 101z"/>
      <path d="M4235 2198 c-3 -7 -4 -348 -3 -758 l3 -745 207 -3 208 -2 2 287 3
      288 277 3 278 2 2 -287 3 -288 207 -3 208 -2 5 22 c3 13 4 354 3 758 l-3 735
      -210 0 -210 0 -3 -283 -2 -282 -278 2 -277 3 -3 283 -2 282 -205 0 c-155 0
      -207 -3 -210 -12z"/>
      <path d="M8015 2198 c-3 -7 -4 -348 -3 -758 l3 -745 555 0 555 0 3 182 2 183
      -347 2 -348 3 -3 573 -2 572 -205 0 c-155 0 -207 -3 -210 -12z"/>
      <path d="M11190 1450 l0 -760 210 0 210 0 0 760 0 760 -210 0 -210 0 0 -760z"/>
      <path d="M12050 1450 l0 -760 203 2 202 3 3 433 c1 237 6 432 10 432 4 0 42
      -51 84 -113 42 -62 96 -139 120 -173 24 -33 78 -111 121 -172 43 -62 82 -112
      86 -112 4 0 25 26 47 57 22 32 112 160 199 286 87 125 162 227 167 227 4 0 8
      -196 8 -435 l0 -435 205 0 c113 0 205 3 205 8 0 4 0 345 0 757 l1 750 -219 3
      -219 2 -179 -271 c-194 -293 -213 -319 -220 -304 -3 6 -89 136 -192 290 l-187
      280 -222 3 -223 2 0 -760z"/>
      <path d="M1039 1776 c-105 -45 -201 -111 -282 -193 -158 -160 -239 -331 -269
      -563 -22 -179 26 -407 122 -574 84 -147 240 -284 398 -350 149 -63 356 -89
      513 -67 416 61 712 350 781 763 7 44 12 176 13 328 l0 255 -325 0 -325 0 -3
      -348 -2 -347 -258 2 -257 3 -3 563 c-2 440 -5 562 -15 562 -6 0 -46 -15 -88
      -34z"/>
    `,
    relevancia: 10
  },

  {
    id: 2,
    payed : true,
    nombre: "Kubiec",
    enlace: "https://kubiec.com/",
    categoria: "principales",
    subcategoria: ["bricks", "blocks", "hormigon", "estructuras"],
    descripcion: "Kubiec existe para acelerar el cambio hacia una construcción sustentable, para mejorar la vida de las personas y proteger el ambiente.",
    svgContent: `
      <path d="M7055 3143 c-22 -15 -137 -86 -255 -158 -359 -220 -1052 -644 -1290
      -790 -124 -76 -277 -169 -340 -208 -245 -148 -475 -290 -484 -299 -6 -4 387
      -8 872 -8 l882 0 2 327 3 327 320 198 c176 108 328 196 337 194 9 -2 161 -92
      337 -201 l321 -197 0 -324 0 -324 877 0 c737 0 875 2 863 14 -8 7 -49 33 -90
      58 -41 25 -304 186 -585 358 -280 172 -571 350 -645 395 -74 45 -234 143 -355
      217 -121 74 -314 192 -430 263 -115 70 -229 141 -252 157 -23 15 -43 28 -45
      27 -2 0 -21 -12 -43 -26z"/>
      <path d="M4677 1404 c-4 -4 -7 -209 -7 -456 l0 -448 105 0 105 0 0 111 0 111
      62 70 c50 56 63 67 74 56 6 -7 64 -88 128 -180 l117 -168 120 0 c77 0 119 4
      117 10 -3 10 -75 118 -250 372 -85 123 -96 144 -84 157 7 9 81 92 165 186 83
      93 151 173 151 177 0 5 -51 8 -113 8 l-113 0 -178 -197 c-99 -109 -183 -199
      -187 -201 -5 -2 -10 86 -11 195 l-3 198 -95 3 c-53 1 -99 0 -103 -4z"/>
      <path d="M5607 1404 c-12 -12 -8 -558 4 -616 25 -118 107 -216 217 -260 48
      -19 76 -22 182 -23 119 0 128 1 190 31 109 52 176 136 200 252 6 27 9 167 8
      332 l-3 285 -95 0 -95 0 -5 -290 c-6 -316 -9 -333 -66 -387 -38 -35 -74 -48
      -135 -48 -53 0 -111 20 -142 48 -50 45 -52 59 -57 377 l-5 300 -95 3 c-53 1
      -99 0 -103 -4z"/>
      <path d="M6598 1404 c-5 -4 -8 -209 -8 -456 l0 -450 279 4 278 3 68 35 c94 49
      128 97 133 191 3 49 -1 83 -12 114 -19 48 -81 111 -121 121 -34 8 -32 17 10
      37 118 56 127 255 14 336 -77 56 -119 64 -389 68 -135 3 -248 1 -252 -3z m435
      -175 c49 -13 77 -44 77 -87 0 -81 -42 -102 -205 -102 l-115 0 0 93 c0 52 3 97
      7 100 10 11 194 8 236 -4z m41 -363 c41 -17 66 -51 66 -91 0 -17 -7 -41 -16
      -54 -29 -40 -73 -51 -209 -51 l-125 0 0 105 0 105 125 0 c85 0 136 -5 159 -14z"/>
      <path d="M7507 1404 c-4 -4 -7 -209 -7 -456 l0 -448 100 0 100 0 -2 453 -3
      452 -90 3 c-50 1 -94 0 -98 -4z"/>
      <path d="M7907 1403 c-4 -3 -7 -208 -7 -455 l0 -448 346 2 346 3 0 80 0 80
      -246 3 -247 2 3 98 3 97 218 3 218 2 -3 83 -3 82 -217 3 -218 2 0 95 0 95 240
      0 241 0 -3 88 -3 87 -331 3 c-182 1 -333 -1 -337 -5z"/>
      <path d="M9031 1395 c-135 -38 -247 -131 -303 -251 -25 -54 -32 -83 -36 -158
      -8 -151 36 -265 139 -361 147 -136 361 -164 544 -73 44 22 145 97 145 107 0 3
      -34 26 -76 50 l-75 43 -68 -31 c-114 -52 -224 -41 -308 33 -149 131 -116 368
      62 452 76 36 154 33 239 -9 l66 -34 77 46 c42 25 76 51 76 56 0 16 -117 91
      -180 115 -76 29 -225 37 -302 15z"/>
      <path d="M5135 390 c-11 -4 -29 -17 -39 -29 -19 -21 -19 -21 1 -21 18 0 71 45
      62 54 -2 2 -13 0 -24 -4z"/>
      <path d="M5294 306 c-33 -14 -44 -33 -44 -70 0 -31 27 -53 91 -74 41 -13 54
      -22 54 -37 0 -31 -47 -43 -91 -22 -28 14 -39 15 -50 6 -20 -16 -18 -22 15 -42
      39 -23 122 -23 150 1 11 9 24 31 27 47 8 44 -22 76 -88 95 -41 12 -53 20 -53
      35 0 16 8 21 38 23 21 2 45 -2 53 -9 11 -9 17 -9 29 1 23 19 18 30 -20 46 -42
      17 -71 17 -111 0z"/>
      <path d="M5655 306 c-47 -21 -67 -51 -73 -107 -9 -97 45 -153 141 -148 29 2
      58 0 65 -5 18 -11 34 6 39 41 16 129 15 148 -8 177 -40 51 -106 68 -164 42z
      m115 -58 c23 -25 29 -65 14 -107 -4 -11 -7 -11 -22 2 -25 23 -52 6 -35 -22 14
      -23 8 -31 -24 -31 -40 0 -73 42 -73 93 0 58 27 87 80 87 27 0 45 -7 60 -22z"/>
      <path d="M8613 313 c-13 -2 -36 -18 -53 -34 -83 -84 -23 -229 94 -229 62 0
      120 44 89 67 -13 10 -21 9 -41 -7 -35 -28 -69 -25 -104 10 -27 27 -30 36 -25
      73 4 26 14 48 27 59 27 22 78 23 107 3 23 -16 56 -10 50 9 -2 6 -18 21 -37 34
      -31 21 -57 25 -107 15z"/>
      <path d="M9323 300 c-66 -40 -86 -103 -55 -173 24 -54 62 -77 127 -77 37 0 52
      6 82 33 31 29 37 41 40 88 3 42 0 61 -17 87 -36 59 -118 78 -177 42z m126 -56
      c31 -39 28 -89 -8 -125 -34 -34 -68 -37 -104 -9 -31 25 -41 62 -27 106 14 41
      33 53 82 54 28 0 41 -6 57 -26z"/>
      <path d="M4672 183 c3 -124 4 -128 26 -131 21 -3 22 -1 22 89 0 52 4 89 8 84
      5 -6 24 -47 42 -93 18 -46 37 -81 42 -80 6 2 27 44 47 93 l36 90 3 -93 c3 -90
      4 -93 25 -90 21 3 22 8 25 131 l3 128 -38 -3 c-36 -3 -38 -5 -69 -83 l-32 -80
      -20 45 c-10 25 -25 62 -33 83 -12 34 -16 37 -51 37 l-39 0 3 -127z"/>
      <path d="M5023 184 c-39 -97 -47 -127 -37 -131 21 -8 45 5 51 27 5 17 14 20
      64 20 54 0 61 -2 71 -25 7 -16 19 -25 35 -25 12 0 23 3 23 8 0 4 -21 62 -47
      129 -47 120 -49 123 -79 123 -30 0 -32 -3 -81 -126z m117 -21 c0 -8 -14 -13
      -40 -13 -44 0 -43 -6 -9 78 l11 27 19 -40 c10 -22 19 -46 19 -52z"/>
      <path d="M5882 209 c4 -99 4 -102 36 -130 27 -24 41 -29 83 -29 43 0 55 5 80
      29 28 29 29 32 29 130 l0 101 -25 0 c-25 0 -25 0 -25 -94 0 -87 -2 -96 -22
      -110 -33 -23 -64 -19 -87 10 -17 22 -21 41 -21 110 0 84 0 84 -26 84 l-26 0 4
      -101z"/>
      <path d="M6162 183 l3 -128 90 0 c73 0 90 3 90 15 0 11 -16 16 -65 20 l-65 5
      0 35 0 35 63 3 c54 3 62 6 62 22 0 18 -7 20 -65 20 l-65 0 0 30 c0 29 0 29 67
      32 54 2 67 6 69 21 2 15 -8 17 -92 17 l-95 0 3 -127z"/>
      <path d="M6490 209 c0 -98 1 -101 29 -130 24 -24 38 -29 76 -29 49 0 82 13
      102 39 8 10 12 54 13 119 0 95 -1 102 -20 102 -18 0 -20 -7 -20 -84 0 -69 -4
      -88 -21 -110 -23 -29 -54 -33 -87 -10 -20 14 -22 23 -22 110 0 94 0 94 -25 94
      l-25 0 0 -101z"/>
      <path d="M6770 179 c0 -130 0 -130 23 -127 20 3 22 9 27 87 l5 85 64 -88 c50
      -69 68 -86 85 -84 20 3 21 9 24 131 l3 127 -26 0 c-25 0 -25 -1 -25 -80 0 -44
      -3 -80 -7 -79 -5 0 -34 36 -65 80 -46 62 -63 79 -83 79 l-25 0 0 -131z"/>
      <path d="M7150 180 l0 -130 76 0 c85 0 111 10 125 47 10 28 -5 83 -23 83 -5 0
      -2 10 6 22 21 30 20 71 -2 91 -14 13 -38 17 -100 17 l-82 0 0 -130z m145 60
      c0 -23 -4 -25 -47 -28 -48 -3 -48 -3 -48 28 0 31 0 31 48 28 43 -3 47 -5 47
      -28z m-1 -86 c9 -8 16 -19 16 -24 0 -21 -34 -40 -71 -40 -39 0 -39 0 -39 40 0
      40 0 40 39 40 23 0 46 -7 55 -16z"/>
      <path d="M7402 204 c3 -102 4 -107 31 -130 33 -28 101 -33 146 -9 38 19 51 60
      51 161 0 82 -1 84 -24 84 -24 0 -24 -2 -28 -96 -2 -81 -6 -98 -22 -110 -28
      -20 -63 -17 -86 6 -17 17 -20 33 -20 110 l0 90 -26 0 -26 0 4 -106z"/>
      <path d="M7680 180 l0 -130 90 0 c83 0 90 2 90 20 0 16 -8 19 -62 22 l-63 3 0
      35 0 35 63 3 c53 3 63 6 60 20 -3 13 -16 18 -66 20 -61 3 -62 3 -62 32 l0 30
      65 0 c58 0 65 2 65 20 0 19 -7 20 -90 20 l-90 0 0 -130z"/>
      <path d="M7902 183 c3 -124 4 -128 26 -131 21 -3 22 -1 22 82 0 47 3 86 8 86
      4 0 34 -39 67 -85 45 -63 66 -85 83 -85 22 0 22 2 22 130 l0 130 -25 0 c-23 0
      -24 -2 -27 -81 l-3 -82 -58 82 c-51 70 -63 81 -88 81 l-30 0 3 -127z"/>
      <path d="M8313 197 c-24 -61 -46 -120 -49 -130 -5 -13 -1 -17 20 -17 19 0 29
      7 36 25 9 23 15 25 68 25 53 0 60 -2 70 -25 8 -17 20 -25 37 -25 14 0 25 2 25
      4 0 2 -22 59 -50 127 -27 68 -50 124 -50 126 0 2 -15 3 -32 3 -33 0 -33 -1
      -75 -113z m99 3 l16 -50 -39 0 c-21 0 -39 3 -39 7 0 15 33 93 39 93 4 0 14
      -22 23 -50z"/>
      <path d="M8800 180 l0 -131 87 3 c73 3 88 6 91 20 3 14 -7 18 -64 20 -73 3
      -72 2 -65 68 1 6 28 10 61 10 53 0 60 2 60 20 0 16 -8 19 -61 22 -59 3 -62 4
      -65 30 -3 27 -2 27 64 30 54 2 67 6 70 21 3 15 -6 17 -87 17 l-91 0 0 -130z"/>
      <path d="M9020 180 l0 -130 25 0 c23 0 25 3 25 51 0 46 2 50 22 47 14 -2 32
      -20 48 -48 19 -33 33 -46 53 -48 33 -4 34 4 2 50 -14 20 -25 39 -25 42 0 3 11
      16 25 30 33 33 34 84 2 114 -20 19 -35 22 -100 22 l-77 0 0 -130z m138 78 c32
      -32 1 -68 -57 -68 -29 0 -31 2 -31 40 0 40 0 40 38 40 21 0 43 -5 50 -12z"/>
    `,
    relevancia: 10
  },

  // OTROS DESORDENADO POR LOS POSITIVOS
  {
    id: 100,
    payed : true,
    nombre: "Acimco",
    enlace: "https://www.acimco.com/",
    categoria: "materiales",
    subcategoria: [],
    descripcion: "Acimco ofrece soluciones innovadoras en fachadas y cubiertas arquitectónicas. Descubre nuestros productos de alta calidad y durabilidad.",
    svgContent: `
      <path d="M1166 2918 c-26 -58 -116 -256 -286 -628 -62 -135 -203 -445 -315
      -690 -111 -245 -282 -618 -379 -829 -97 -212 -176 -389 -176 -393 0 -5 95 -7
      210 -6 l211 3 100 220 c55 121 127 280 161 353 l61 132 643 0 644 0 20 -42
      c11 -24 83 -182 160 -353 l139 -310 206 -3 c113 -1 205 1 205 6 0 10 -169 385
      -774 1722 -86 190 -209 463 -274 607 l-117 262 -208 1 -207 0 -24 -52z m349
      -675 c61 -135 167 -370 236 -522 l125 -276 -474 -3 c-262 -1 -477 -1 -479 1
      -4 5 470 1046 477 1046 3 0 55 -110 115 -246z"/>
      <path d="M3719 2966 c-2 -3 -49 -12 -104 -21 -553 -87 -953 -462 -1066 -998
      -28 -131 -31 -376 -6 -512 62 -339 254 -635 532 -820 424 -283 1055 -299 1485
      -40 91 56 238 179 259 218 14 26 13 29 -30 69 -24 24 -86 83 -136 132 l-92 89
      -63 -58 c-123 -112 -238 -177 -383 -216 -67 -19 -106 -22 -245 -22 -146 0
      -176 2 -261 25 -322 87 -552 318 -631 636 -31 122 -30 350 1 467 89 334 341
      568 689 640 101 21 304 21 407 0 157 -32 308 -112 429 -228 l60 -57 135 133
      c75 72 137 135 139 138 6 12 -138 147 -211 197 -141 97 -333 176 -497 202 -41
      6 -94 16 -117 21 -42 9 -286 13 -294 5z"/>
      <path d="M5186 2961 c-3 -5 -6 -586 -6 -1292 l0 -1284 72 -5 c40 -3 134 -6
      208 -5 l135 0 7 710 c4 391 7 973 5 1295 l-2 585 -207 3 c-117 1 -209 -2 -212
      -7z"/>
      <path d="M7450 2861 c-129 -48 -347 -128 -485 -178 -137 -51 -356 -131 -485
      -178 -129 -47 -289 -106 -355 -130 -66 -24 -128 -46 -138 -50 -16 -7 -17 -60
      -15 -979 l3 -971 205 0 205 0 3 803 c2 629 5 804 15 807 6 2 205 74 441 160
      236 85 436 155 444 155 13 0 14 -124 11 -962 l-4 -963 208 -3 207 -2 0 277 c0
      153 3 531 7 840 l6 562 56 20 c31 11 231 83 444 160 214 78 391 141 393 141 2
      0 4 -450 4 -1000 l0 -1000 210 0 210 0 2 1283 c2 705 0 1286 -3 1290 -3 4
      -178 -55 -390 -132 -211 -77 -505 -184 -654 -238 l-270 -99 -3 238 c-2 219 -4
      238 -20 237 -9 -1 -123 -40 -252 -88z"/>
      <path d="M10380 2935 c-221 -30 -444 -117 -603 -233 -254 -186 -421 -442 -490
      -752 -29 -131 -31 -433 -3 -559 58 -266 160 -457 340 -636 180 -179 384 -289
      637 -344 390 -84 786 -18 1082 180 74 50 203 163 218 191 10 18 -5 35 -128
      153 l-138 132 -65 -60 c-181 -167 -369 -239 -625 -240 -435 0 -767 239 -886
      638 -30 102 -38 331 -15 445 36 178 119 332 243 455 157 156 361 240 613 251
      268 13 486 -64 670 -235 35 -34 66 -61 68 -61 10 0 272 257 272 266 0 25 -189
      190 -275 241 -255 152 -589 213 -915 168z"/>
      <path d="M12742 2939 c-282 -20 -561 -131 -775 -309 -300 -250 -466 -639 -444
      -1040 12 -197 45 -328 132 -505 171 -353 492 -594 913 -687 143 -32 442 -32
      592 1 253 54 472 167 644 331 191 182 312 400 367 662 42 200 27 479 -36 672
      -28 85 -101 237 -148 306 -221 327 -600 543 -991 566 -50 3 -102 6 -116 8 -14
      1 -76 -1 -138 -5z m296 -400 c157 -24 325 -103 442 -207 374 -332 388 -972 27
      -1325 -153 -150 -355 -233 -594 -244 -285 -14 -529 74 -712 257 -74 75 -106
      120 -160 227 -64 128 -85 228 -85 413 -1 130 3 169 22 240 123 459 553 718
      1060 639z"/>
      <path d="M768 73 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
      <path d="M9943 73 c26 -2 68 -2 95 0 26 2 4 3 -48 3 -52 0 -74 -1 -47 -3z"/>
    `,
    relevancia: 9
  },

  {
    id: 101,
    payed : true,
    nombre: "Cedal",
    enlace: "https://cedal.com.ec/",
    categoria: "materiales",
    subcategoria: [],
    descripcion: "Calidad de Vida",
    svgContent: `
      <path d="M7020 3149 c-461 -39 -878 -120 -1245 -244 -649 -217 -1117 -552
      -1300 -929 -66 -136 -88 -226 -89 -376 -1 -150 17 -233 79 -366 77 -165 192
      -310 352 -444 501 -419 1267 -676 2258 -756 219 -18 706 -15 905 6 376 38 683
      90 945 162 567 154 1004 375 1296 656 163 156 261 303 326 487 26 75 27 90 28
      245 0 155 -2 170 -28 250 -70 209 -207 397 -410 567 -476 396 -1257 664 -2155
      738 -197 16 -789 19 -962 4z m885 -80 c838 -51 1639 -301 2114 -659 231 -175
      382 -367 457 -585 26 -73 28 -93 29 -225 0 -125 -3 -155 -23 -220 -114 -360
      -465 -678 -1007 -910 -405 -174 -864 -283 -1440 -344 -271 -28 -748 -31 -1040
      -6 -1344 116 -2355 636 -2520 1295 -26 101 -24 266 4 370 89 331 399 639 880
      872 677 327 1571 472 2546 412z"/>
      <path d="M7205 3034 c-22 -2 -107 -8 -190 -15 -964 -70 -1801 -376 -2222 -812
      -203 -210 -290 -412 -280 -647 29 -700 1092 -1288 2522 -1394 1269 -95 2530
      222 3103 778 215 208 315 415 315 651 0 135 -23 229 -87 353 -283 547 -1176
      953 -2346 1067 -153 15 -719 28 -815 19z m-964 -514 c105 -23 222 -75 298
      -132 l55 -42 -93 -87 -94 -87 -51 32 c-137 87 -333 117 -514 80 -156 -32 -271
      -93 -383 -205 -87 -86 -142 -185 -157 -281 -37 -236 164 -482 443 -543 64 -15
      105 -17 220 -12 77 4 156 10 176 13 l36 6 6 117 c11 199 58 332 150 424 89 90
      234 134 338 104 106 -31 151 -115 130 -242 -20 -117 -67 -202 -188 -341 -35
      -41 -58 -74 -51 -74 41 0 138 25 178 45 67 34 95 69 140 180 72 173 173 305
      281 368 90 53 222 71 326 43 l51 -14 48 127 c62 166 134 334 192 451 l47 95
      103 3 c82 2 102 0 102 -11 0 -8 -14 -47 -31 -88 -187 -449 -389 -1054 -389
      -1168 0 -21 3 -23 32 -17 52 10 104 70 129 145 73 222 207 397 355 462 61 28
      193 37 272 19 48 -11 56 -10 64 4 13 22 233 24 225 2 -49 -127 -151 -495 -163
      -590 l-7 -49 57 6 c58 6 133 40 147 67 4 8 14 70 23 137 44 339 136 652 245
      838 55 93 154 188 221 211 111 37 257 8 307 -62 99 -139 7 -415 -275 -824 -78
      -114 -213 -293 -254 -337 -28 -29 -29 -32 -12 -41 77 -41 253 -34 379 14 13 5
      14 -3 9 -57 -4 -35 -11 -70 -17 -77 -6 -8 -43 -30 -81 -50 -68 -35 -75 -37
      -171 -37 l-100 0 -86 47 -87 47 -92 -47 c-90 -46 -94 -47 -185 -47 l-93 0 -62
      42 -61 43 -41 -26 c-95 -60 -186 -81 -280 -64 -58 11 -148 50 -193 83 -18 14
      -23 13 -52 -9 -66 -50 -124 -74 -180 -74 -63 0 -100 17 -138 62 -22 26 -30 30
      -43 20 -10 -7 -44 -27 -77 -44 -57 -32 -65 -33 -170 -33 -104 0 -113 2 -170
      32 -33 17 -69 38 -80 46 -17 13 -23 13 -55 -3 -19 -10 -73 -31 -120 -46 -75
      -26 -99 -29 -200 -28 -94 0 -125 4 -171 22 l-56 22 -84 -20 c-114 -26 -240
      -38 -384 -34 -454 10 -769 290 -768 679 2 396 371 760 835 825 86 12 234 3
      339 -20z m3372 -1270 c84 -94 -45 -226 -142 -144 -38 32 -49 80 -27 123 35 67
      118 77 169 21z m-1019 -461 c59 -16 96 -58 96 -109 0 -89 -50 -130 -161 -130
      -100 0 -159 44 -159 120 0 96 105 152 224 119z m-2038 -113 c30 -63 54 -117
      54 -120 0 -3 -22 -6 -49 -6 -41 0 -51 4 -56 20 -5 17 -15 20 -60 20 -45 0 -55
      -3 -60 -20 -5 -16 -15 -20 -56 -20 -27 0 -49 2 -49 4 0 3 25 57 57 120 l56
      116 54 0 54 0 55 -114z m184 24 l0 -90 75 0 75 0 0 -30 0 -30 -125 0 -125 0 0
      120 0 120 50 0 50 0 0 -90z m280 5 c0 -81 1 -86 25 -97 19 -8 31 -8 50 0 24
      11 25 16 25 97 l0 85 50 0 50 0 0 -85 c0 -79 -2 -87 -29 -117 -27 -30 -34 -33
      -105 -36 -135 -7 -166 22 -166 158 l0 80 50 0 50 0 0 -85z m406 28 c9 -32 20
      -62 24 -67 5 -5 17 20 27 55 l19 64 67 3 67 3 0 -121 0 -120 -40 0 -40 0 0 75
      c0 41 -3 75 -7 75 -5 0 -18 -34 -31 -76 l-23 -75 -36 3 c-36 3 -37 4 -64 83
      l-27 80 -1 -82 -1 -83 -40 0 -40 0 0 120 0 120 65 0 64 0 17 -57z m364 -63 l0
      -120 -50 0 -50 0 0 120 0 120 50 0 50 0 0 -120z m214 58 l55 -63 1 63 0 62 45
      0 45 0 0 -120 0 -120 -44 0 c-41 0 -47 4 -100 63 l-55 62 -1 -62 0 -63 -45 0
      -45 0 0 120 0 120 44 0 c41 0 47 -4 100 -62z m306 -58 l0 -120 -45 0 -45 0 0
      120 0 120 45 0 45 0 0 -120z"/>
      <path d="M9207 2298 c-67 -65 -133 -211 -191 -428 -43 -158 -79 -324 -74 -345
      7 -34 272 416 343 583 41 93 55 182 35 207 -22 27 -75 19 -113 -17z"/>
      <path d="M6504 1711 c-20 -12 -42 -40 -57 -73 -40 -84 -72 -268 -48 -268 21 0
      137 154 180 237 49 97 7 154 -75 104z"/>
      <path d="M7293 1700 c-178 -80 -278 -372 -148 -432 87 -40 235 96 287 265 46
      152 -14 224 -139 167z"/>
      <path d="M8204 1699 c-132 -64 -232 -257 -194 -373 15 -46 44 -66 96 -66 75 0
      162 83 223 209 46 97 54 182 21 224 -17 22 -29 27 -63 27 -23 -1 -61 -10 -83
      -21z"/>
      <path d="M9475 1245 c-53 -52 -16 -149 58 -149 66 0 107 60 83 119 -25 59 -97
      75 -141 30z m84 -5 c14 -7 18 -22 19 -65 0 -30 -4 -55 -9 -55 -5 0 -9 11 -9
      25 0 21 -5 25 -29 25 -25 0 -30 -5 -34 -27 -2 -16 -5 2 -6 40 -1 66 0 67 25
      67 14 0 33 -4 43 -10z"/>
      <path d="M9500 1211 c0 -17 6 -21 31 -21 24 0 30 4 27 18 -2 10 -14 18 -31 20
      -22 3 -27 -1 -27 -17z"/>
      <path d="M8492 724 c-25 -17 -31 -84 -9 -102 46 -38 107 -12 109 46 2 60 -51
      90 -100 56z"/>
      <path d="M6431 690 c-15 -46 -14 -50 14 -50 28 0 32 20 11 59 l-13 24 -12 -33z"/>
    `,
    relevancia: 9
  },

  {
    id: 102,
    payed : true,
    nombre: "Inselec",
    enlace: "https://inselec.com.ec/",
    categoria: "materiales",
    subcategoria: [],
    descripcion: "INSELEC – Industria de Sistemas Eléctricos Cía. Ltda",
    svgContent: `
      <path d="M2320 3161 c-94 -29 -181 -105 -227 -199 -24 -50 -28 -69 -28 -147 0
      -77 4 -98 27 -147 35 -76 104 -148 175 -184 53 -26 67 -29 158 -29 88 0 107 3
      157 27 191 89 269 319 170 501 -36 67 -120 141 -187 166 -58 22 -192 28 -245
      12z m237 -89 c57 -30 111 -85 137 -141 32 -70 29 -180 -6 -247 -53 -102 -149
      -159 -263 -158 -85 1 -128 18 -190 75 -63 59 -87 108 -93 195 -4 62 -1 79 22
      130 35 76 67 110 141 146 54 26 68 29 135 25 51 -2 88 -11 117 -25z"/>
      <path d="M2428 2993 c-22 -26 -148 -203 -148 -208 0 -3 25 -5 55 -5 30 0 55
      -4 55 -9 0 -5 -16 -46 -35 -91 -19 -45 -31 -80 -26 -78 16 5 271 232 271 240
      0 4 -31 8 -70 8 -38 0 -70 2 -70 5 0 3 23 36 50 72 28 36 50 70 50 74 0 5 -26
      9 -58 9 -44 0 -63 -5 -74 -17z"/>
      <path d="M5075 2220 c-278 -59 -452 -273 -414 -510 35 -220 198 -343 574 -434
      156 -38 260 -75 295 -105 60 -51 69 -144 18 -198 -44 -47 -96 -66 -183 -67
      -147 -2 -232 63 -273 208 l-16 59 -121 -6 c-272 -14 -356 -20 -360 -28 -12
      -18 28 -161 67 -239 57 -118 145 -204 252 -249 128 -53 205 -65 436 -65 179 0
      215 3 283 22 273 75 432 253 445 498 7 149 -38 267 -136 354 -103 92 -212 136
      -521 211 -112 28 -217 57 -232 64 -88 46 -73 153 25 190 54 21 166 16 214 -9
      43 -22 101 -93 108 -133 4 -19 13 -37 21 -40 13 -5 465 15 471 22 2 1 -4 34
      -13 71 -48 211 -183 338 -408 385 -128 26 -404 26 -532 -1z"/>
      <path d="M11130 2221 c-343 -73 -544 -311 -580 -687 -19 -195 6 -380 71 -522
      56 -125 178 -266 283 -327 74 -44 204 -83 316 -96 124 -14 337 -6 425 15 163
      40 301 138 389 278 35 56 87 174 101 230 8 30 39 17 -275 109 -80 23 -150 44
      -156 46 -5 2 -18 -22 -28 -54 -55 -178 -148 -253 -312 -253 -114 0 -212 56
      -257 145 -45 89 -62 357 -32 499 35 166 145 259 305 260 129 0 233 -66 275
      -177 13 -35 22 -46 34 -43 9 3 108 26 221 51 112 25 206 48 209 50 2 3 -6 28
      -18 57 -71 170 -183 299 -315 363 -113 54 -228 75 -416 74 -109 0 -180 -6
      -240 -18z"/>
      <path d="M2187 2213 c-4 -3 -7 -366 -7 -805 l0 -798 260 0 260 0 0 805 0 805
      -253 0 c-140 0 -257 -3 -260 -7z"/>
      <path d="M2922 1415 l3 -806 235 0 235 0 5 433 5 433 184 -265 c101 -146 236
      -340 300 -432 l116 -168 243 0 242 0 0 805 0 805 -240 0 -240 0 0 -435 c0
      -239 -3 -435 -7 -435 -5 0 -28 31 -53 67 -25 37 -118 173 -208 303 -90 129
      -204 295 -255 368 l-91 132 -238 0 -238 0 2 -805z"/>
      <path d="M6190 1415 l0 -805 693 2 692 3 0 180 0 180 -438 3 -438 2 3 153 3
      152 393 3 392 2 0 165 0 165 -392 2 -393 3 0 120 0 120 423 3 422 2 0 175 0
      175 -680 0 -680 0 0 -805z"/>
      <path d="M7705 2208 c-3 -7 -4 -368 -3 -803 l3 -790 648 -3 647 -2 0 200 0
      200 -390 2 -390 3 -3 600 -2 600 -253 3 c-197 2 -254 0 -257 -10z"/>
      <path d="M9090 1415 l0 -805 690 0 690 0 0 185 0 185 -435 0 -436 0 3 153 3
      152 393 3 392 2 0 165 0 165 -395 0 -395 0 0 125 0 125 425 0 425 0 0 175 0
      175 -680 0 -680 0 0 -805z"/>
      <path d="M7997 460 c-25 -35 -26 -41 -12 -46 11 -4 28 5 51 27 32 31 33 35 17
      46 -24 18 -25 17 -56 -27z"/>
      <path d="M11640 330 c0 -87 -1 -90 -19 -80 -11 5 -37 10 -58 10 -72 0 -119
      -78 -93 -154 6 -20 23 -44 36 -53 29 -19 98 -21 119 -3 10 8 15 9 15 1 0 -6 9
      -11 20 -11 19 0 20 7 20 190 0 183 -1 190 -20 190 -19 0 -20 -7 -20 -90z m-18
      -127 c25 -22 24 -84 -2 -108 -44 -40 -110 -9 -110 53 0 20 7 44 17 54 20 22
      70 23 95 1z"/>
      <path d="M2250 222 l0 -183 23 3 c21 3 22 6 22 126 0 67 3 122 6 122 3 0 61
      -58 128 -130 68 -72 127 -130 132 -130 6 0 8 72 7 177 -3 170 -4 178 -23 178
      -19 0 -20 -8 -23 -122 -1 -68 -5 -123 -7 -123 -3 0 -64 60 -135 133 l-129 132
      -1 -183z"/>
      <path d="M4152 238 c-94 -216 -89 -198 -60 -198 19 0 28 10 45 50 l22 51 68
      -3 68 -3 23 -47 c18 -38 28 -48 47 -48 l24 0 -33 78 c-106 246 -122 282 -127
      282 -3 0 -37 -73 -77 -162z m104 5 c11 -27 21 -51 22 -55 2 -5 -19 -8 -47 -8
      -28 0 -51 3 -51 6 0 14 43 104 50 104 4 0 16 -21 26 -47z"/>
      <path d="M6400 400 c0 -3 -16 -81 -35 -175 -19 -93 -35 -173 -35 -178 0 -5 10
      -7 23 -5 19 3 24 14 42 100 11 53 22 99 25 102 3 3 28 -44 54 -105 27 -60 52
      -109 55 -109 3 0 28 50 56 110 47 104 65 130 65 94 0 -9 7 -56 16 -105 15 -83
      18 -89 41 -89 18 0 23 4 19 18 -3 9 -17 82 -31 162 -31 170 -35 185 -44 174
      -4 -5 -31 -63 -60 -129 -29 -66 -56 -123 -59 -127 -4 -4 -31 50 -61 120 -47
      110 -71 158 -71 142z"/>
      <path d="M6818 227 c-43 -95 -78 -176 -78 -180 0 -5 10 -7 22 -5 16 2 30 18
      46 51 l22 48 68 -3 67 -3 23 -47 c18 -38 27 -48 47 -48 29 0 31 -6 -43 156
      -27 60 -58 130 -68 156 -10 27 -21 48 -24 48 -3 0 -40 -78 -82 -173z m109 8
      l21 -55 -49 0 c-27 0 -49 3 -49 6 0 12 43 104 49 104 3 0 16 -25 28 -55z"/>
      <path d="M2147 384 c-4 -4 -7 -83 -7 -176 l0 -169 23 3 c22 3 22 4 22 173 0
      145 -2 170 -15 173 -9 1 -19 0 -23 -4z"/>
      <path d="M2637 383 c-4 -3 -7 -82 -7 -175 l0 -168 58 0 c83 0 125 15 165 59
      89 98 39 252 -91 280 -59 12 -115 14 -125 4z m153 -58 c16 -9 37 -30 46 -47
      21 -40 14 -120 -12 -149 -24 -27 -75 -49 -114 -49 l-30 0 0 130 0 130 40 0
      c23 0 54 -7 70 -15z"/>
      <path d="M2950 247 c0 -138 1 -145 24 -170 52 -56 151 -54 201 4 25 31 26 33
      23 168 -3 125 -4 136 -22 136 -17 0 -18 -8 -17 -108 3 -159 -15 -197 -92 -197
      -61 0 -71 23 -77 173 -4 115 -7 132 -22 135 -17 3 -18 -9 -18 -141z"/>
      <path d="M3295 367 c-19 -16 -27 -33 -28 -59 -1 -46 13 -63 85 -99 65 -33 82
      -56 69 -92 -11 -27 -29 -37 -72 -37 -23 0 -34 7 -47 30 -19 33 -20 34 -42 20
      -13 -8 -13 -13 0 -37 8 -16 32 -36 52 -46 30 -15 44 -16 76 -8 50 14 72 39 79
      91 7 51 -16 79 -99 121 -61 31 -72 53 -42 83 20 20 53 20 75 0 21 -19 61 -10
      52 12 -17 44 -116 58 -158 21z"/>
      <path d="M3492 368 c2 -19 10 -24 40 -26 l37 -3 3 -147 c3 -144 3 -147 26
      -150 22 -3 22 -3 22 147 l0 151 40 0 c36 0 40 3 40 25 l0 25 -106 0 c-104 0
      -105 0 -102 -22z"/>
      <path d="M3740 215 c0 -168 1 -175 20 -175 18 0 20 7 20 70 0 39 3 70 8 70 4
      0 29 -32 55 -70 37 -55 53 -70 73 -70 13 0 24 3 24 6 0 3 -22 37 -50 75 l-50
      69 30 15 c36 19 50 43 50 88 0 62 -52 96 -147 97 l-33 0 0 -175z m124 103 c9
      -12 16 -28 16 -35 0 -23 -39 -53 -70 -53 -30 0 -30 1 -30 55 l0 55 34 0 c25 0
      39 -7 50 -22z"/>
      <path d="M3997 383 c-4 -3 -7 -82 -7 -175 0 -161 1 -168 20 -168 19 0 20 7 20
      175 0 139 -3 175 -13 175 -8 0 -17 -3 -20 -7z"/>
      <path d="M4567 383 c-4 -3 -7 -82 -7 -175 l0 -168 58 0 c84 0 125 15 165 59
      64 71 57 185 -13 245 -41 34 -182 61 -203 39z m153 -58 c86 -44 76 -193 -15
      -231 -19 -8 -48 -14 -64 -14 l-30 0 -3 130 -3 130 43 0 c24 0 56 -7 72 -15z"/>
      <path d="M4880 215 l0 -175 90 0 c83 0 90 1 90 20 0 18 -7 20 -70 20 l-70 0 0
      65 0 65 71 0 c62 0 70 2 67 18 -3 14 -16 18 -71 20 l-67 3 0 44 0 44 68 3 c61
      3 67 5 70 26 3 21 1 22 -87 22 l-91 0 0 -175z"/>
      <path d="M5309 375 c-15 -8 -32 -29 -38 -46 -16 -47 3 -78 74 -116 73 -38 89
      -60 76 -96 -18 -47 -102 -49 -122 -3 -8 16 -17 22 -30 19 -23 -6 -24 -21 -3
      -52 26 -36 77 -54 123 -41 49 13 71 39 78 89 8 55 -11 80 -85 115 -68 32 -83
      57 -56 87 21 23 57 25 78 4 15 -15 38 -20 49 -9 11 11 -5 35 -34 49 -35 19
      -76 18 -110 0z"/>
      <path d="M5527 384 c-4 -4 -7 -83 -7 -176 l0 -168 25 0 25 0 -2 172 c-3 147
      -5 173 -18 176 -9 1 -19 0 -23 -4z"/>
      <path d="M5680 377 c-46 -23 -60 -86 -27 -125 6 -8 37 -27 69 -43 65 -33 82
      -56 69 -92 -11 -27 -29 -37 -72 -37 -23 0 -34 7 -47 30 -19 33 -20 34 -42 20
      -13 -8 -13 -13 0 -37 8 -16 32 -36 52 -46 74 -36 158 16 158 99 0 37 -34 71
      -107 108 -36 18 -53 32 -53 45 0 45 62 67 94 35 19 -19 58 -10 49 12 -14 37
      -95 55 -143 31z"/>
      <path d="M5864 375 c-10 -24 5 -35 47 -35 l39 0 0 -150 c0 -143 1 -150 20
      -150 19 0 20 7 20 150 l0 150 39 0 c38 0 59 19 45 41 -3 5 -50 9 -105 9 -78 0
      -101 -3 -105 -15z"/>
      <path d="M6117 383 c-4 -3 -7 -82 -7 -175 l0 -168 90 0 c83 0 90 2 90 20 0 17
      -8 19 -67 22 l-68 3 0 60 0 60 68 3 c59 3 67 5 67 22 0 18 -7 20 -70 20 l-70
      0 0 45 0 45 70 0 c68 0 70 1 70 25 0 25 -1 25 -83 25 -46 0 -87 -3 -90 -7z"/>
      <path d="M7119 361 c-54 -54 -30 -109 71 -159 45 -22 56 -33 58 -56 8 -65 -78
      -92 -119 -37 -23 31 -49 31 -49 1 0 -9 11 -29 25 -42 64 -64 174 -31 191 57 9
      50 -15 81 -92 120 -52 27 -59 33 -59 60 0 23 6 32 26 39 27 9 40 6 71 -16 14
      -10 20 -10 30 0 11 11 8 18 -15 38 -41 35 -99 33 -138 -5z"/>
      <path d="M7497 384 c-4 -4 -7 -83 -7 -176 l0 -168 95 0 c88 0 95 1 95 20 0 18
      -7 20 -70 20 l-70 0 0 65 0 64 68 3 c52 2 67 6 67 18 0 12 -15 16 -67 18 l-68
      3 0 44 0 44 68 3 c59 3 67 5 67 23 0 18 -8 20 -85 23 -47 1 -89 0 -93 -4z"/>
      <path d="M7740 215 l0 -175 70 0 c63 0 70 2 70 20 0 17 -7 20 -50 20 l-50 0 0
      155 c0 148 -1 155 -20 155 -19 0 -20 -7 -20 -175z"/>
      <path d="M7917 384 c-4 -4 -7 -83 -7 -176 l0 -168 95 0 c88 0 95 2 95 20 0 17
      -8 19 -72 22 l-73 3 0 60 0 60 68 3 c58 3 67 5 67 22 0 17 -9 19 -67 22 l-68
      3 -3 42 -3 42 73 3 c65 3 73 5 73 23 0 18 -8 20 -85 23 -47 1 -89 0 -93 -4z"/>
      <path d="M8245 376 c-37 -16 -92 -77 -101 -112 -21 -82 20 -175 93 -209 77
      -37 185 -16 191 38 l3 28 -33 -21 c-74 -45 -172 -15 -203 62 -28 72 2 145 71
      174 45 19 73 18 119 -6 22 -11 41 -20 42 -20 2 0 3 11 3 26 0 19 -8 28 -35 40
      -42 17 -110 18 -150 0z"/>
      <path d="M8460 365 c0 -23 4 -25 40 -25 l40 0 0 -150 0 -150 25 0 25 0 0 149
      0 150 38 3 c29 2 37 7 37 23 0 19 -8 20 -102 23 l-103 3 0 -26z"/>
      <path d="M8705 378 c-3 -7 -4 -86 -3 -173 3 -157 3 -160 26 -163 21 -3 22 -1
      22 74 l0 77 51 -72 c51 -73 65 -85 94 -79 12 2 4 19 -35 73 -46 64 -49 71 -33
      82 9 7 20 13 25 13 11 0 38 56 38 79 0 59 -35 87 -125 97 -42 5 -56 4 -60 -8z
      m123 -50 c14 -14 16 -57 4 -76 -5 -7 -25 -15 -45 -19 l-37 -6 0 57 0 56 33 0
      c18 0 38 -5 45 -12z"/>
      <path d="M8960 216 c0 -170 1 -176 20 -176 20 0 20 5 18 172 -3 155 -5 173
      -20 176 -17 3 -18 -10 -18 -172z"/>
      <path d="M9144 370 c-145 -72 -126 -280 31 -325 31 -9 65 -13 82 -9 50 12 83
      34 83 54 0 23 -17 25 -44 5 -11 -8 -40 -15 -65 -15 -151 0 -194 186 -59 256
      37 19 77 18 123 -6 22 -11 41 -20 42 -20 2 0 3 11 3 26 0 51 -119 72 -196 34z"/>
      <path d="M9485 374 c-70 -36 -105 -91 -105 -166 1 -161 218 -234 323 -109 100
      119 16 290 -143 291 -25 0 -58 -7 -75 -16z m144 -42 c66 -35 90 -125 51 -189
      -25 -41 -68 -63 -124 -63 -85 0 -149 85 -127 168 24 86 121 127 200 84z"/>
      <path d="M9838 374 c-41 -22 -54 -91 -23 -123 8 -8 40 -28 72 -45 50 -27 58
      -36 61 -62 4 -41 -20 -64 -64 -64 -27 0 -38 6 -52 28 -10 17 -24 26 -34 24
      -38 -8 -5 -66 49 -88 72 -30 153 20 153 95 0 47 -23 72 -100 111 -64 32 -75
      54 -42 83 23 21 51 22 79 2 21 -15 53 -11 53 6 0 16 -64 49 -95 49 -16 -1 -42
      -7 -57 -16z"/>
      <path d="M10272 369 c-71 -35 -112 -124 -92 -198 30 -113 156 -168 263 -114
      18 9 27 21 27 38 l0 25 -37 -20 c-100 -54 -213 9 -213 117 0 62 73 133 135
      133 17 0 48 -9 70 -20 48 -25 45 -25 45 4 0 53 -119 74 -198 35z"/>
      <path d="M11200 216 l0 -176 70 0 c63 0 70 2 70 20 0 17 -7 20 -50 20 l-49 0
      -3 152 c-3 136 -5 153 -20 156 -17 3 -18 -10 -18 -172z"/>
      <path d="M10544 345 c-21 -28 -24 -39 -15 -48 9 -9 20 -2 49 26 31 31 34 39
      22 47 -23 15 -27 13 -56 -25z"/>
      <path d="M11377 334 c-4 -4 -7 -22 -7 -41 0 -18 -4 -33 -10 -33 -5 0 -10 -9
      -10 -20 0 -11 5 -20 10 -20 6 0 10 -37 10 -91 0 -88 1 -90 23 -87 21 3 22 8
      25 91 2 68 6 87 17 87 8 0 15 9 15 20 0 11 -6 20 -14 20 -10 0 -16 13 -18 37
      -3 36 -23 54 -41 37z"/>
      <path d="M10530 150 c0 -110 0 -111 23 -108 21 3 22 7 22 108 0 101 -1 105
      -22 108 -23 3 -23 2 -23 -108z"/>
      <path d="M10677 249 c-47 -27 -62 -127 -27 -172 27 -34 79 -51 114 -38 14 6
      39 8 56 5 l30 -7 0 112 c0 103 -1 111 -19 111 -11 0 -21 -6 -24 -12 -4 -10 -7
      -10 -18 0 -16 14 -87 16 -112 1z m122 -63 c30 -64 -27 -133 -86 -104 -38 18
      -50 61 -29 105 15 32 19 34 59 31 35 -2 44 -8 56 -32z"/>
      <path d="M11774 245 c-47 -32 -57 -133 -19 -175 26 -28 77 -43 109 -31 14 6
      39 8 56 5 l30 -7 0 112 c0 103 -1 111 -19 111 -11 0 -21 -6 -24 -12 -4 -10 -7
      -10 -18 0 -18 17 -90 15 -115 -3z m120 -47 c30 -42 15 -101 -30 -118 -71 -27
      -124 69 -68 124 24 24 80 20 98 -6z"/>
      <path d="M10926 73 c-4 -9 0 -23 9 -32 13 -14 17 -14 31 1 9 9 14 24 11 32 -8
      21 -43 20 -51 -1z"/>
      <path d="M12030 74 c-11 -12 -10 -18 3 -32 16 -15 18 -15 33 0 19 18 12 48 -9
      48 -8 0 -20 -7 -27 -16z"/>
    `,
    relevancia: 9
  },

  {
    id: 103,
    payed : true,
    nombre: "Vesbo",
    enlace: "https://vesbo.com/es/vesbo-ppr-es/",
    categoria: "materiales",
    subcategoria: [],
    descripcion: "VESBO PPR, PP-R, Pioneer Brand inPPR Pipe Technology, Approved and certified by water auhoritites and testing bodies all over the world, VESBO PP-R pipes and fittings bring safety, health and comfort to your homes in more than 75 countries across 5 continents, Complete System up to 250mm!, Its superior physical and chemical properties combined with its comprehensive range of products make VESBO PPR a versatile piping system in a wide range of applications in different industries.",
    svgContent: `
      <path d="M1617 3186 c-105 -29 -190 -125 -202 -230 -3 -28 -5 -652 -3 -1386 3
      -1489 -3 -1365 74 -1450 50 -55 105 -82 180 -88 116 -9 217 47 268 150 l26 52
      0 1375 0 1376 -24 50 c-25 55 -87 117 -139 139 -53 22 -127 27 -180 12z"/>
      <path d="M2348 3186 c-84 -23 -157 -89 -187 -169 -8 -19 -11 -463 -11 -1405
      l0 -1377 24 -50 c24 -52 72 -102 129 -132 23 -13 55 -18 117 -18 75 0 91 3
      131 27 54 32 102 83 127 136 16 35 17 124 17 1412 l0 1375 -21 46 c-57 123
      -199 190 -326 155z"/>
      <path d="M3100 3191 c-89 -20 -165 -81 -199 -161 l-21 -49 2 -1383 3 -1383 27
      -47 c57 -96 151 -145 262 -136 34 3 77 13 96 23 48 24 107 82 133 130 l22 40
      0 1385 0 1385 -22 41 c-35 66 -70 101 -126 128 -59 28 -125 38 -177 27z"/>
      <path d="M8489 1985 c-183 -35 -334 -128 -415 -257 -96 -151 -109 -420 -29
      -585 65 -132 177 -205 458 -297 218 -71 298 -123 313 -201 15 -83 -16 -139
      -102 -181 -50 -25 -62 -26 -142 -21 -72 4 -111 14 -224 56 -155 57 -220 65
      -274 32 -63 -38 -114 -133 -114 -210 0 -54 45 -137 93 -172 92 -66 213 -111
      369 -134 122 -19 190 -19 298 -1 166 27 272 78 376 181 119 117 167 246 168
      445 1 137 -21 222 -82 315 -78 121 -184 188 -437 275 -213 73 -275 106 -299
      153 -16 33 -17 45 -7 77 21 69 102 120 192 120 20 0 97 -16 172 -35 155 -40
      202 -43 257 -15 107 55 131 217 45 317 -41 48 -136 100 -230 125 -95 26 -285
      32 -386 13z"/>
      <path d="M11553 1986 c-326 -62 -556 -268 -661 -591 -44 -134 -56 -223 -56
      -395 0 -174 16 -277 65 -418 115 -329 354 -523 704 -572 250 -35 534 49 705
      207 203 188 300 441 300 784 0 258 -59 474 -178 648 -105 154 -276 272 -467
      322 -103 27 -310 34 -412 15z m262 -401 c102 -17 223 -113 279 -222 53 -105
      70 -194 71 -358 0 -167 -14 -241 -68 -355 -42 -90 -133 -179 -211 -209 -162
      -60 -344 -26 -451 86 -51 52 -106 160 -132 253 -26 94 -25 347 1 445 56 211
      180 339 352 364 59 8 82 8 159 -4z"/>
      <path d="M12750 1971 c-72 -22 -139 -81 -166 -147 -24 -56 -18 -152 12 -212
      99 -198 396 -180 469 29 60 169 -65 341 -245 338 -25 0 -56 -4 -70 -8z m135
      -42 c78 -22 145 -119 145 -210 0 -37 -31 -113 -58 -142 -53 -59 -173 -76 -247
      -34 -119 68 -141 239 -41 336 56 54 124 71 201 50z"/>
      <path d="M12730 1725 c0 -138 1 -145 20 -145 18 0 20 7 20 65 0 62 1 65 25 65
      19 0 32 -13 62 -65 32 -54 42 -65 65 -65 l27 0 -38 62 -39 61 31 21 c42 29 50
      86 16 122 -20 22 -31 24 -106 24 l-83 0 0 -145z m155 65 c0 -33 -2 -35 -43
      -43 -61 -12 -72 -5 -72 43 l0 41 58 -3 57 -3 0 -35z"/>
      <path d="M5335 1952 c-48 -23 -97 -74 -115 -120 -26 -67 -12 -113 275 -877
      152 -407 286 -758 297 -780 50 -99 111 -144 196 -145 83 0 142 41 188 132 32
      64 568 1471 583 1530 16 69 14 116 -10 165 -51 105 -194 144 -290 80 -71 -48
      -87 -84 -279 -615 -101 -281 -187 -512 -190 -512 -3 0 -86 228 -185 506 -99
      279 -192 526 -206 549 -43 69 -91 99 -163 102 -45 3 -72 -1 -101 -15z"/>
      <path d="M7006 1945 c-58 -21 -88 -46 -113 -95 l-23 -44 0 -804 0 -804 27 -50
      c19 -34 41 -58 72 -76 l46 -27 354 -3 c370 -3 430 1 482 39 93 66 100 242 14
      318 -20 17 -37 32 -38 33 -1 1 -123 4 -272 7 l-270 6 -3 177 -2 176 232 4
      c255 4 270 7 321 67 36 43 50 94 45 161 -5 75 -40 130 -100 159 -41 19 -60 21
      -271 21 l-227 0 2 173 3 172 248 2 c280 2 299 7 345 76 20 29 27 56 30 104 8
      114 -38 186 -133 212 -63 17 -719 14 -769 -4z"/>
      <path d="M9558 1950 c-55 -16 -97 -51 -120 -98 l-23 -47 0 -805 0 -805 25 -45
      c28 -50 74 -85 134 -101 67 -18 684 -6 765 15 111 29 189 72 267 150 108 109
      153 227 154 401 0 227 -113 402 -302 466 l-47 16 45 34 c104 78 156 188 155
      333 0 152 -47 263 -152 361 -61 57 -173 111 -259 125 -76 12 -602 12 -642 0z
      m572 -406 c51 -29 74 -75 74 -148 0 -76 -24 -128 -73 -158 -32 -20 -52 -23
      -168 -26 l-133 -4 0 182 0 182 133 -4 c110 -3 138 -7 167 -24z m97 -750 c73
      -37 103 -84 103 -163 0 -68 -28 -128 -73 -158 -47 -32 -119 -43 -283 -43
      l-144 0 0 193 c0 107 3 197 8 201 4 5 80 6 169 4 156 -4 164 -6 220 -34z"/>
      <path d="M3732 1932 c-177 -64 -256 -259 -173 -427 59 -118 141 -163 320 -175
      90 -5 130 -12 163 -29 69 -33 121 -83 159 -153 32 -59 34 -69 34 -158 0 -84
      -3 -102 -28 -151 -33 -69 -100 -132 -174 -166 -46 -21 -78 -27 -177 -33 -136
      -7 -173 -21 -240 -87 -146 -144 -106 -395 78 -491 44 -22 66 -27 162 -30 136
      -5 229 9 357 52 137 47 243 114 352 221 143 141 232 303 270 494 23 111 17
      335 -12 436 -61 213 -179 390 -345 516 -175 131 -333 186 -563 195 -111 4
      -138 2 -183 -14z"/>
    `,
    relevancia: 8
  },

  {
    id: 104,
    payed : true,
    nombre: "Sherwin Williams",
    enlace: "https://sherwin-williams.com.ec/",
    categoria: "materiales",
    subcategoria: [],
    descripcion: "Sherwin Williams Ecuador -Sherwin Williams Ecuador",
    svgContent: `
      <path d="M4588 3160 c-91 -27 -210 -127 -277 -230 -65 -101 -77 -170 -32 -185
      30 -9 105 -104 135 -169 40 -88 86 -140 126 -143 19 -1 37 -6 41 -10 19 -19
      58 -105 64 -140 4 -21 9 -51 12 -68 5 -30 5 -30 -32 13 -62 71 -117 90 -156
      51 -16 -16 -20 -29 -15 -50 5 -26 3 -29 -20 -29 -46 0 -93 -27 -110 -64 -16
      -32 -16 -36 0 -61 15 -22 15 -26 2 -31 -9 -3 -25 -22 -37 -41 -16 -26 -20 -45
      -16 -79 4 -43 4 -45 -44 -79 -60 -45 -134 -125 -185 -202 -118 -179 -172 -442
      -129 -633 8 -36 20 -104 27 -151 11 -79 10 -98 -10 -200 -29 -151 -29 -193 3
      -224 29 -30 45 -31 78 -5 37 29 43 76 23 179 -10 47 -19 94 -21 104 -2 9 -2
      17 -1 17 2 0 24 -27 50 -60 29 -38 44 -66 39 -73 -4 -7 -13 -41 -20 -77 -6
      -36 -23 -119 -37 -185 -34 -159 -22 -215 48 -215 84 1 94 61 46 291 -42 203
      -42 203 24 141 62 -58 156 -122 221 -149 27 -11 45 -24 45 -34 0 -9 -9 -61
      -20 -115 -12 -55 -22 -123 -23 -152 -2 -48 1 -56 26 -78 36 -31 61 -30 92 1
      31 30 32 68 5 200 -28 135 -27 139 13 131 285 -59 548 9 749 193 37 34 84 85
      105 113 l37 51 18 -59 c10 -32 21 -76 24 -97 19 -113 55 8 64 218 4 88 13 211
      20 273 36 329 -97 636 -351 809 l-46 32 5 50 c4 47 2 53 -29 84 -19 18 -43 39
      -54 45 -16 9 -18 13 -7 23 31 32 7 95 -41 104 -30 6 -33 10 -29 34 3 21 -3 33
      -23 50 -15 11 -34 21 -42 21 -29 0 -90 -40 -116 -76 l-27 -39 0 116 0 117 55
      42 c105 81 205 216 205 277 0 21 -5 33 -13 33 -24 0 -49 38 -50 75 -1 30 -10
      44 -49 81 -27 25 -68 54 -92 65 -46 20 -146 124 -146 152 0 26 -46 34 -102 17z
      m57 -40 c3 -5 0 -10 -7 -10 -31 0 -142 -63 -190 -107 -58 -54 -123 -149 -133
      -193 -8 -34 -25 -40 -25 -9 0 39 64 143 125 204 81 81 211 146 230 115z m136
      -145 c62 -69 118 -124 125 -121 6 2 17 -1 23 -7 18 -18 12 -44 -12 -51 -37 -9
      -145 -83 -197 -136 -27 -26 -68 -77 -90 -112 -58 -92 -59 -92 -81 -72 -10 9
      -19 25 -19 35 0 9 -47 68 -105 131 -57 62 -104 121 -105 131 0 37 54 130 112
      193 58 62 175 134 218 134 9 0 68 -56 131 -125z m120 -54 c32 -29 38 -38 23
      -35 -24 6 -95 74 -77 74 6 0 30 -18 54 -39z m53 -140 c3 -5 -13 -19 -37 -31
      -101 -53 -215 -161 -270 -258 -22 -39 -33 -50 -41 -42 -35 35 142 244 259 307
      63 34 80 39 89 24z m-451 -288 c2 -13 3 -23 2 -23 -6 0 -65 97 -65 106 1 16
      59 -60 63 -83z m-98 -713 c22 -24 12 -39 -15 -22 -30 18 -49 15 -61 -12 -8
      -17 -8 -29 0 -45 12 -22 47 -29 53 -10 2 6 13 10 23 8 19 -4 19 -5 -3 -27 -25
      -25 -59 -28 -88 -8 -14 11 -19 26 -19 61 0 35 5 50 19 61 28 20 70 17 91 -6z
      m67 -37 c3 -51 6 -58 25 -61 20 -3 22 1 25 55 2 44 7 58 18 58 22 0 26 -89 5
      -121 -18 -28 -65 -33 -89 -8 -22 21 -23 134 -1 134 10 0 15 -15 17 -57z m207
      47 c14 -7 18 -22 19 -65 0 -51 -2 -57 -26 -66 -14 -6 -40 -9 -56 -7 -30 3 -31
      4 -34 62 -2 32 -1 65 2 72 6 16 68 19 95 4z m155 -12 c8 -12 12 -26 9 -32 -4
      -5 -6 -30 -4 -54 2 -48 -19 -56 -29 -11 -4 15 -14 25 -27 27 -17 3 -22 -3 -25
      -24 -2 -15 -9 -29 -15 -32 -10 -3 -13 16 -13 72 l0 76 44 0 c35 0 48 -5 60
      -22z m144 5 c2 -9 -9 -13 -37 -13 -30 0 -41 -4 -41 -15 0 -10 11 -15 35 -15
      44 0 46 -18 3 -22 -22 -2 -34 -9 -36 -20 -3 -15 4 -18 37 -18 30 0 41 -4 41
      -16 0 -12 -10 -14 -52 -12 l-53 3 -3 59 c-4 82 -1 88 55 84 26 -2 48 -9 51
      -15z m82 -30 l30 -48 0 48 c0 35 4 47 15 47 12 0 15 -15 15 -75 0 -91 -15 -99
      -57 -27 l-28 47 -3 -48 c-4 -69 -26 -56 -30 18 -5 99 12 111 58 38z m-430
      -207 c0 -54 0 -55 32 -58 55 -5 46 -28 -11 -28 l-51 0 0 70 c0 56 3 70 15 70
      11 0 15 -13 15 -54z m186 -3 c10 -32 20 -64 22 -70 5 -18 -25 -16 -32 2 -3 8
      -16 15 -30 15 -13 0 -26 -7 -30 -15 -4 -13 -36 -22 -36 -11 0 4 22 66 39 109
      18 47 45 35 67 -30z m-356 -148 c0 -8 -9 -15 -20 -15 -18 0 -20 -7 -20 -55 0
      -42 -3 -55 -15 -55 -12 0 -15 13 -15 55 0 48 -2 55 -20 55 -11 0 -20 7 -20 15
      0 12 13 15 55 15 42 0 55 -3 55 -15z m50 -55 c0 -56 -3 -70 -15 -70 -12 0 -15
      14 -15 70 0 56 3 70 15 70 12 0 15 -14 15 -70z m130 55 c0 -10 -11 -15 -35
      -15 -19 0 -35 -4 -35 -10 0 -5 14 -10 30 -10 20 0 30 -5 30 -15 0 -10 -10 -15
      -30 -15 -23 0 -30 -4 -30 -20 0 -16 7 -20 35 -20 19 0 35 -4 35 -10 0 -5 -22
      -10 -50 -10 l-50 0 0 70 0 70 50 0 c38 0 50 -4 50 -15z m140 -5 c6 -11 8 -26
      4 -32 -4 -7 -7 -29 -5 -50 1 -29 -2 -38 -14 -38 -9 0 -15 9 -15 25 0 20 -5 25
      -25 25 -20 0 -25 -5 -25 -25 0 -16 -6 -25 -15 -25 -12 0 -15 14 -15 70 l0 70
      50 0 c39 0 51 -4 60 -20z m144 -2 c8 -13 8 -23 0 -35 -6 -10 -7 -32 -3 -51 5
      -27 4 -32 -10 -30 -9 2 -17 13 -19 26 -5 34 -52 31 -52 -3 0 -16 -6 -25 -15
      -25 -12 0 -15 15 -15 71 l0 70 51 -3 c36 -2 55 -8 63 -20z m111 5 c4 -10 15
      -42 25 -70 19 -52 19 -53 -1 -53 -10 0 -19 7 -19 15 0 9 -9 15 -25 15 -14 0
      -28 -7 -31 -15 -6 -16 -34 -21 -34 -7 0 4 9 36 21 70 15 45 26 62 39 62 10 0
      21 -8 25 -17z m57 -223 c56 -74 83 -102 110 -116 52 -27 68 -50 68 -99 0 -39
      -3 -45 -21 -45 -33 0 -54 16 -124 96 l-66 76 23 27 c18 21 19 22 2 8 -28 -23
      -36 -22 -59 12 -11 17 -21 28 -23 26 -2 -2 7 -18 20 -35 l23 -32 -35 -30 c-19
      -16 -28 -26 -20 -22 8 4 24 15 36 26 20 18 21 18 97 -66 79 -87 83 -103 23
      -92 -27 5 -37 1 -60 -23 -28 -29 -28 -51 -1 -51 20 0 7 -38 -16 -45 -10 -4
      -23 -4 -29 0 -5 3 -15 -3 -22 -15 -18 -28 -52 -26 -66 5 -10 22 -9 27 6 32 18
      7 42 28 42 37 0 10 -40 7 -61 -4 -26 -14 -25 4 2 72 13 32 24 92 29 151 9 109
      23 137 71 137 19 0 35 -9 51 -30z m-561 -10 c4 -14 15 -50 24 -81 9 -30 15
      -66 13 -80 -3 -23 -4 -23 -21 9 -15 27 -16 36 -6 49 11 12 10 14 -4 11 -11 -2
      -27 13 -47 42 -16 25 -30 39 -30 32 0 -8 9 -27 21 -43 11 -16 19 -36 16 -43
      -6 -15 -175 -112 -189 -109 -14 5 -9 -11 22 -75 17 -34 30 -69 30 -76 0 -8
      -19 -18 -47 -25 l-48 -10 48 3 c27 2 53 8 59 14 6 6 0 34 -20 81 l-30 71 71
      41 c40 23 83 48 95 56 13 8 25 13 26 11 36 -51 44 -79 39 -144 -3 -38 -11 -73
      -17 -77 -7 -5 -6 -7 4 -5 8 1 24 -3 35 -9 28 -15 63 1 71 33 4 15 2 55 -5 89
      -18 100 -15 123 22 165 17 20 37 45 43 55 15 28 31 11 44 -47 7 -29 34 -100
      60 -158 49 -109 69 -183 51 -194 -5 -4 -14 1 -19 10 -8 14 -13 14 -52 -6 -44
      -22 -55 -19 -62 15 -3 17 -11 20 -50 20 -45 0 -47 -1 -44 -25 1 -14 8 -37 14
      -52 15 -37 47 -217 39 -224 -11 -12 -37 5 -37 24 0 11 -7 25 -15 32 -16 14
      -11 49 9 62 7 5 3 8 -8 8 -19 0 -19 0 -1 14 19 13 18 19 -7 87 -19 50 -33 66
      -69 73 -17 3 -37 12 -45 20 -14 15 -51 15 -89 0 -22 -9 -110 -95 -125 -124 -5
      -10 -7 -26 -4 -34 4 -11 0 -16 -12 -17 -16 0 -15 -2 4 -9 25 -11 28 -25 9 -44
      -25 -26 -53 -27 -78 -5 -13 11 -18 18 -11 14 28 -14 9 4 -30 29 -43 27 -43 27
      -13 2 21 -18 25 -26 14 -26 -22 0 -52 36 -57 66 -2 23 0 25 20 19 20 -6 21 -6
      7 6 -9 8 -19 26 -21 42 -5 23 -2 27 21 28 l26 2 -27 4 c-20 3 -30 12 -34 31
      -4 15 -11 33 -17 40 -6 8 -6 12 0 12 6 0 23 34 38 77 l28 76 14 -49 c24 -86
      26 -128 9 -203 -17 -73 -14 -94 18 -120 19 -16 52 0 61 30 4 12 2 56 -5 98
      -11 72 -10 79 14 144 16 41 26 88 26 120 0 64 11 80 73 106 26 11 64 32 85 46
      44 30 64 29 73 -5z m858 -63 c6 -8 11 -49 11 -93 0 -43 4 -97 10 -119 14 -57
      12 -108 -5 -131 -16 -22 -15 -26 -18 66 -1 25 -6 51 -11 58 -5 8 -4 18 3 25 6
      6 11 15 11 21 0 5 -6 1 -14 -9 -8 -11 -19 -16 -30 -12 -26 10 -22 81 10 195 4
      16 19 15 33 -1z m-1307 -234 c5 -7 7 -16 4 -22 -3 -5 1 -22 9 -37 8 -16 15
      -55 15 -88 0 -68 -9 -66 -59 13 -33 51 -37 74 -21 117 10 26 11 26 33 8 l22
      -19 -22 26 c-23 26 -29 50 -16 63 4 4 12 -5 17 -21 5 -15 13 -33 18 -40z
      m1113 -49 c-22 -19 -51 -45 -65 -58 -14 -13 -40 -24 -58 -25 -39 -2 -39 14 -1
      38 23 15 23 15 10 -2 -10 -13 -11 -17 -1 -17 7 0 34 23 60 50 31 33 55 50 71
      50 22 -1 21 -3 -16 -36z m-257 -36 c19 -19 14 -37 -8 -31 -24 6 -34 19 -25 33
      8 13 18 13 33 -2z m-213 -108 c21 -40 19 -47 -11 -53 -20 -3 -27 1 -35 20 -5
      13 -9 33 -9 44 0 31 37 24 55 -11z m46 -71 c9 -18 7 -26 -17 -50 -27 -28 -54
      -38 -54 -20 0 5 -3 16 -6 25 -4 11 0 16 14 16 12 0 24 5 28 11 5 8 -1 10 -20
      7 -34 -7 -30 14 5 23 37 11 38 10 50 -12z m29 -67 c0 -16 -27 -45 -39 -41 -8
      3 -7 11 4 27 16 22 35 30 35 14z m-66 -43 c-8 -14 -34 -10 -34 5 0 9 7 12 20
      9 11 -3 17 -9 14 -14z m-34 -52 c0 -23 -58 -77 -82 -77 -7 0 2 10 19 23 22 15
      33 30 33 48 0 14 3 29 6 32 11 11 24 -3 24 -26z m33 12 c4 -16 11 -19 26 -14
      16 5 22 1 27 -19 8 -34 -1 -56 -25 -56 -24 0 -51 41 -51 80 0 34 15 40 23 9z"/>
      <path d="M4618 3039 c-11 -6 -18 -22 -18 -39 0 -33 27 -55 112 -93 55 -24 76
      -42 64 -54 -4 -4 -12 -1 -18 5 -14 14 -48 16 -48 4 0 -5 11 -19 24 -31 28 -26
      73 -25 90 2 20 31 -12 68 -92 108 -40 19 -78 41 -84 47 -18 18 -3 24 26 11 19
      -9 30 -9 38 -1 8 8 2 16 -23 31 -38 24 -47 25 -71 10z"/>
      <path d="M4515 2979 c-4 -5 4 -27 17 -47 62 -94 63 -98 6 -43 -53 50 -78 59
      -78 25 0 -17 142 -274 151 -274 4 0 10 7 13 16 4 11 -11 48 -39 98 l-46 81 65
      -64 c55 -54 67 -62 80 -52 14 11 11 20 -21 69 -20 32 -43 68 -51 82 -9 14 14
      -4 50 -39 47 -45 71 -62 83 -57 9 3 15 9 13 14 -2 4 -48 51 -104 105 -96 92
      -125 110 -139 86z"/>
      <path d="M4405 2849 c-4 -5 5 -27 20 -49 21 -31 25 -45 20 -74 -6 -28 -2 -45
      19 -81 41 -69 92 -86 122 -40 16 25 16 27 -71 140 -47 63 -90 115 -95 115 -5
      0 -12 -5 -15 -11z m145 -216 c0 -22 -17 -14 -44 18 -14 17 -26 40 -26 52 1 19
      5 17 35 -18 19 -22 35 -46 35 -52z"/>
      <path d="M4613 1758 c2 -7 14 -13 27 -13 13 0 25 6 28 13 2 8 -7 12 -28 12
      -21 0 -30 -4 -27 -12z"/>
      <path d="M4615 1711 c-10 -17 4 -31 31 -31 19 0 25 5 22 18 -4 19 -43 29 -53
      13z"/>
      <path d="M4760 1755 c0 -21 27 -30 45 -15 19 16 10 30 -21 30 -15 0 -24 -6
      -24 -15z"/>
      <path d="M4770 1553 c0 -6 -3 -18 -6 -27 -4 -11 -1 -16 10 -16 9 0 16 6 16 13
      0 16 -20 46 -20 30z"/>
      <path d="M4700 1371 c0 -16 6 -21 26 -21 33 0 30 33 -4 38 -17 3 -22 -2 -22
      -17z"/>
      <path d="M4847 1383 c-4 -3 -7 -12 -7 -20 0 -16 46 -18 56 -2 11 19 -33 39
      -49 22z"/>
      <path d="M5000 1340 c0 -11 7 -20 15 -20 17 0 18 2 9 24 -9 23 -24 20 -24 -4z"/>
      <path d="M5243 958 c-20 -26 -26 -41 -15 -34 12 7 36 46 29 46 -3 0 -9 -6 -14
      -12z"/>
      <path d="M4786 922 c-3 -5 -32 -19 -66 -33 -33 -13 -60 -27 -60 -31 0 -12 3
      -11 74 22 61 28 90 50 67 50 -5 0 -12 -4 -15 -8z"/>
      <path d="M4237 569 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
      <path d="M6305 2613 c-100 -22 -178 -72 -210 -133 -25 -48 -29 -125 -11 -175
      20 -52 61 -90 150 -140 36 -20 79 -52 97 -72 27 -32 31 -41 26 -80 -12 -111
      -135 -152 -292 -98 -38 13 -73 20 -76 17 -8 -8 -39 -115 -35 -119 2 -2 41 -13
      87 -24 104 -27 234 -23 319 10 125 47 193 178 156 303 -18 65 -61 108 -167
      172 -83 50 -109 79 -109 123 0 90 130 128 270 78 24 -8 45 -13 47 -11 8 8 36
      117 31 121 -22 22 -223 42 -283 28z"/>
      <path d="M6676 2423 c-60 -273 -133 -630 -129 -635 2 -5 33 -8 69 -8 76 0 73
      -5 104 145 12 55 24 110 27 123 5 21 9 22 129 22 68 0 124 -3 124 -7 0 -5 -14
      -66 -29 -138 -16 -71 -27 -133 -24 -137 2 -5 33 -8 69 -8 57 0 65 2 74 23 8
      17 140 625 140 643 0 2 -33 4 -74 4 -68 0 -74 -2 -79 -22 -3 -13 -15 -71 -27
      -130 l-23 -108 -123 0 c-97 0 -124 3 -124 13 0 8 11 65 25 127 14 62 25 115
      25 117 0 1 -33 3 -74 3 -73 0 -75 -1 -80 -27z"/>
      <path d="M7326 2433 c-9 -30 -136 -628 -136 -641 0 -9 52 -12 200 -12 l200 0
      10 24 c5 13 12 40 15 60 l7 36 -131 0 c-131 0 -131 0 -126 23 3 12 11 49 18
      82 l14 60 116 3 c128 3 119 -2 132 79 l7 42 -114 3 -114 3 14 68 15 67 128 0
      c70 0 130 3 132 8 3 4 8 31 12 60 l7 52 -200 0 c-182 0 -201 -2 -206 -17z"/>
      <path d="M7811 2348 c-12 -56 -43 -204 -70 -328 -27 -124 -46 -228 -44 -232 2
      -5 35 -8 73 -8 64 0 70 2 75 23 3 12 16 72 28 132 l23 110 42 3 c53 4 64 -13
      87 -138 25 -133 23 -130 104 -130 37 0 70 2 73 5 9 9 -63 288 -79 306 -12 14
      -8 18 31 33 77 30 124 108 113 189 -7 48 -32 85 -78 112 -29 17 -56 20 -195
      23 l-161 4 -22 -104z m280 -28 c14 -8 19 -21 19 -49 0 -54 -40 -87 -115 -96
      -31 -4 -59 -5 -62 -1 -3 3 -1 32 6 63 21 99 16 93 77 93 31 0 64 -5 75 -10z"/>
      <path d="M8330 2434 c0 -52 42 -639 46 -646 9 -13 160 -10 172 5 6 6 51 103
      100 214 131 292 121 281 122 137 0 -66 3 -176 7 -243 l6 -122 86 3 86 3 79
      160 c43 88 116 238 162 333 l83 172 -78 0 -77 0 -84 -177 c-46 -98 -95 -203
      -109 -233 l-26 -55 -3 233 -2 232 -98 0 -97 0 -100 -230 c-55 -126 -102 -230
      -105 -230 -6 0 -6 -6 -15 253 l-7 207 -74 0 c-61 0 -74 -3 -74 -16z"/>
      <path d="M9266 2133 c-37 -175 -68 -325 -69 -333 -2 -12 13 -16 67 -18 38 -2
      73 1 77 5 4 4 37 148 74 318 36 171 68 318 71 328 5 15 -3 17 -74 17 l-78 0
      -68 -317z"/>
      <path d="M9526 2133 c-38 -175 -72 -326 -74 -336 -4 -16 2 -18 68 -15 l73 3
      47 220 c26 121 49 226 51 234 3 8 34 -91 70 -220 l64 -234 91 -3 c88 -3 92 -2
      97 20 4 13 36 158 72 323 36 165 67 306 70 313 3 9 -15 12 -69 12 l-73 0 -49
      -230 c-27 -126 -52 -226 -55 -222 -4 4 -35 107 -70 230 l-63 222 -90 0 -91 0
      -69 -317z"/>
      <path d="M5923 1478 c12 -256 39 -684 43 -696 3 -9 27 -12 96 -10 l92 3 136
      328 c76 180 140 331 144 334 3 3 6 -57 6 -134 0 -77 3 -228 7 -336 l6 -197 87
      0 c60 0 91 4 98 13 8 10 331 714 369 805 4 10 -12 12 -73 10 l-79 -3 -140
      -320 -140 -320 -6 320 c-3 176 -7 321 -7 323 -1 1 -47 1 -103 0 l-101 -3 -119
      -290 c-65 -159 -124 -301 -131 -315 l-12 -25 -6 35 c-3 19 -7 87 -9 150 -2 63
      -6 189 -10 280 l-6 165 -74 3 -74 3 6 -123z"/>
      <path d="M9896 1436 c-80 -30 -129 -85 -140 -158 -12 -81 19 -140 97 -189 85
      -53 107 -78 107 -119 0 -58 -36 -85 -113 -84 -42 0 -76 7 -105 21 -30 15 -44
      18 -47 10 -2 -7 -11 -35 -19 -63 -14 -51 -14 -52 11 -63 44 -20 156 -34 213
      -27 123 16 197 88 207 204 7 84 -22 133 -112 195 -79 53 -95 71 -95 103 0 56
      91 80 180 49 23 -8 44 -15 46 -15 4 0 36 112 32 115 -39 32 -198 45 -262 21z"/>
      <path d="M6941 1128 c-34 -172 -65 -323 -68 -336 -5 -23 -4 -23 68 -20 l74 3
      67 330 c37 182 67 331 67 333 1 1 -32 2 -73 2 l-73 0 -62 -312z"/>
      <path d="M7245 1428 c-2 -7 -32 -150 -65 -318 -34 -168 -63 -313 -66 -323 -5
      -16 7 -17 187 -15 l193 3 12 58 11 57 -118 0 c-89 0 -119 3 -119 13 0 6 23
      122 50 256 28 134 50 252 50 262 0 17 -8 19 -65 19 -44 0 -67 -4 -70 -12z"/>
      <path d="M7685 1418 c-18 -77 -125 -614 -125 -630 0 -17 9 -18 187 -16 l187 3
      13 50 c7 28 13 53 13 58 0 4 -54 7 -120 7 -66 0 -120 4 -120 8 0 8 94 471 105
      520 5 21 3 22 -65 22 -64 0 -70 -2 -75 -22z"/>
      <path d="M8061 1123 c-34 -175 -64 -326 -67 -335 -5 -16 3 -18 69 -18 l74 0
      63 323 c35 177 65 328 68 335 3 9 -15 12 -70 12 l-74 0 -63 -317z"/>
      <path d="M8384 1128 c-98 -171 -185 -322 -192 -335 l-13 -23 78 0 78 0 40 75
      40 75 126 0 127 0 9 -72 8 -73 59 -3 c32 -2 64 -1 71 1 8 4 -5 96 -46 333 -32
      181 -58 330 -58 332 -1 1 -34 2 -74 2 l-73 0 -180 -312z m246 26 l16 -114 -84
      0 -83 0 62 120 c35 66 65 117 68 114 3 -3 13 -57 21 -120z"/>
      <path d="M9005 1418 c-18 -77 -125 -618 -125 -631 0 -14 11 -17 65 -17 36 0
      65 2 65 4 0 15 92 445 98 460 5 11 15 -60 26 -185 9 -112 20 -221 23 -242 l6
      -38 64 3 65 3 120 233 c66 128 122 231 124 229 2 -2 -19 -106 -46 -232 -28
      -126 -50 -230 -50 -232 0 -2 33 -3 74 -3 l73 0 62 313 c34 171 65 322 68 335
      l5 23 -112 -3 -112 -3 -111 -217 c-62 -120 -114 -218 -118 -218 -3 0 -11 69
      -17 153 -7 83 -15 182 -19 220 l-6 67 -108 0 c-104 0 -109 -1 -114 -22z"/>
      <path d="M10205 951 c-73 -30 -82 -132 -14 -166 39 -20 72 -19 102 5 53 42 43
      125 -18 154 -37 18 -41 18 -70 7z m80 -45 c18 -27 17 -77 -1 -83 -18 -6 -25
      26 -11 48 10 17 9 22 -8 35 -11 8 -29 13 -40 12 -17 -3 -21 -12 -23 -55 -2
      -32 1 -53 7 -53 6 0 11 9 11 20 0 11 4 20 9 20 5 0 13 -9 16 -20 3 -11 12 -20
      18 -20 16 0 -14 -20 -31 -20 -21 0 -62 47 -62 72 0 64 82 95 115 44z m-34 -21
      c-1 -15 -24 -12 -29 3 -3 9 2 13 12 10 10 -1 17 -7 17 -13z"/>
      <path d="M5460 467 c0 -13 -14 -73 -31 -133 -39 -138 -42 -199 -10 -225 30
      -24 56 -24 81 1 25 25 26 88 6 187 -8 37 -18 96 -22 131 -6 59 -24 88 -24 39z"/>
    `,
    relevancia: 8
  },

  {
    id: 105,
    payed : true,
    nombre: "Novacero",
    enlace: "https://www.novacero.com/",
    categoria: "materiales",
    subcategoria: [],
    descripcion: "Fabricamos y comercializamos soluciones de acero generando valor a clientes, comunidad y nuestro personal de forma sostenible.",
    svgContent: `
      <path d="M148 2476 c-76 -129 -140 -240 -143 -248 -3 -8 45 -100 106 -204 62
      -104 135 -227 162 -274 88 -151 160 -274 182 -313 17 -29 24 -35 32 -25 6 7
      50 81 98 163 214 364 254 431 270 453 l16 22 405 0 406 0 -20 33 c-10 17 -45
      77 -77 132 -32 55 -91 154 -130 220 -39 66 -91 155 -116 197 l-44 78 -505 0
      -505 0 -137 -234z"/>
      <path d="M1414 2688 c32 -52 376 -639 376 -642 0 -3 -40 -71 -88 -153 -169
      -282 -302 -510 -308 -527 -6 -15 26 -16 374 -16 l380 0 77 133 c43 72 158 268
      256 434 l178 302 -143 243 -144 243 -486 3 -487 2 15 -22z"/>
      <path d="M3100 2045 l0 -665 185 0 185 0 2 415 3 415 56 -92 c287 -476 433
      -715 441 -725 8 -10 70 -13 249 -13 l239 0 0 665 0 665 -185 0 -186 0 3 -419
      c2 -279 0 -416 -7 -411 -5 5 -120 193 -255 419 l-245 410 -242 1 -243 0 0
      -665z"/>
      <path d="M5188 2700 c-305 -55 -548 -271 -602 -533 -20 -94 -20 -152 -1 -241
      57 -267 281 -467 595 -531 106 -22 290 -16 395 13 444 121 666 545 475 910
      -89 172 -236 288 -450 357 -72 23 -106 28 -225 31 -77 1 -161 -1 -187 -6z
      m292 -303 c85 -31 169 -121 205 -220 24 -67 27 -87 23 -160 -18 -352 -432
      -497 -638 -223 -57 76 -83 162 -78 261 6 104 34 175 98 247 104 116 241 150
      390 95z"/>
      <path d="M6080 2704 c0 -3 46 -123 102 -267 55 -144 113 -293 128 -332 20 -52
      240 -617 277 -712 4 -10 62 -13 243 -13 l237 0 28 63 c15 34 38 85 50 112 13
      28 48 109 80 180 31 72 65 148 75 170 10 22 85 189 165 370 168 379 186 417
      192 428 2 4 -92 7 -209 7 l-213 0 -195 -470 c-107 -259 -198 -466 -202 -462
      -6 6 -230 618 -325 890 l-15 42 -209 0 c-115 0 -209 -2 -209 -6z"/>
      <path d="M7862 2668 c-35 -78 -312 -689 -444 -978 -71 -157 -132 -291 -135
      -298 -4 -10 39 -12 212 -10 l217 3 77 190 77 190 246 3 246 2 47 -137 c26 -76
      57 -163 69 -193 l21 -55 214 -3 c200 -2 213 -1 209 15 -3 10 -126 309 -274
      666 l-269 647 -247 0 -247 0 -19 -42z m332 -436 c33 -92 61 -173 64 -179 3
      -10 -29 -13 -138 -13 -131 0 -142 1 -136 18 33 85 142 342 146 342 3 0 32 -75
      64 -168z"/>
      <path d="M9420 2695 c-282 -58 -483 -228 -556 -470 -25 -84 -25 -277 0 -360
      60 -196 196 -342 391 -420 84 -33 252 -64 353 -65 76 0 255 23 308 40 l31 10
      17 138 c9 75 16 142 16 148 0 7 -24 2 -62 -14 -53 -22 -83 -26 -191 -30 -149
      -5 -226 7 -309 49 -115 58 -173 151 -185 292 -11 130 43 252 143 323 133 95
      366 118 539 53 31 -11 59 -18 62 -15 4 3 -1 70 -10 148 -12 101 -22 146 -32
      154 -43 32 -390 44 -515 19z"/>
      <path d="M10160 2045 l0 -665 510 0 510 0 0 150 0 150 -330 0 -330 0 0 115 0
      115 280 0 280 0 0 135 0 135 -280 0 -280 0 0 115 0 115 330 0 330 0 0 150 0
      150 -510 0 -510 0 0 -665z"/>
      <path d="M11400 2045 l0 -665 190 0 190 0 0 515 0 515 121 0 c139 0 199 -18
      240 -73 31 -42 33 -114 3 -153 -39 -53 -96 -74 -201 -74 -75 0 -93 -3 -93 -15
      0 -8 33 -99 73 -202 41 -103 102 -261 137 -350 l63 -163 208 0 c115 0 209 2
      209 4 0 2 -15 37 -33 77 -19 41 -45 99 -58 128 -13 30 -56 125 -95 210 l-71
      156 56 26 c73 33 150 109 187 184 27 55 29 69 29 165 -1 90 -4 112 -24 153
      -37 76 -113 152 -189 189 l-67 33 -437 3 -438 3 0 -666z"/>
      <path d="M13240 2695 c-157 -31 -308 -112 -415 -221 -72 -73 -117 -147 -152
      -246 -22 -61 -26 -91 -26 -183 0 -94 3 -121 26 -183 86 -238 284 -402 560
      -463 75 -17 114 -20 217 -16 140 6 221 24 328 73 255 116 412 341 412 588 0
      167 -59 305 -185 431 -116 115 -247 186 -410 220 -89 18 -264 18 -355 0z m326
      -306 c75 -35 146 -108 182 -187 35 -76 43 -205 17 -283 -37 -113 -109 -194
      -212 -242 -73 -33 -198 -31 -275 5 -120 56 -205 182 -215 320 -22 296 252 507
      503 387z"/>
      <path d="M750 1673 c-90 -153 -175 -299 -189 -324 l-25 -46 55 -94 c256 -434
      394 -668 411 -691 l19 -28 309 0 308 0 30 47 c77 123 412 701 412 711 0 9 -96
      12 -377 12 l-378 1 -42 72 c-96 167 -355 603 -362 610 -4 4 -81 -117 -171
      -270z"/>
      <path d="M7090 715 l0 -225 130 0 130 0 0 50 0 50 -71 0 -70 0 3 38 3 37 63 3
      62 3 0 49 0 50 -65 0 -65 0 0 35 0 35 70 0 70 0 0 50 0 50 -130 0 -130 0 0
      -225z"/>
      <path d="M7430 715 l0 -226 133 3 132 3 0 45 0 45 -72 3 -73 3 0 174 0 175
      -60 0 -60 0 0 -225z"/>
      <path d="M8071 918 c-5 -13 -43 -108 -85 -211 -42 -103 -76 -194 -76 -202 0
      -12 14 -15 60 -15 l60 0 16 40 16 40 83 0 82 0 16 -40 15 -40 61 0 c33 0 62 3
      64 8 2 4 -35 104 -82 222 l-86 215 -68 3 c-62 3 -68 1 -76 -20z m98 -188 c12
      -30 21 -58 21 -62 0 -5 -21 -8 -46 -8 -33 0 -45 4 -41 13 2 6 13 35 23 64 10
      29 19 51 20 50 1 -1 12 -27 23 -57z"/>
      <path d="M8566 925 c-124 -44 -186 -173 -141 -290 34 -89 153 -155 252 -140
      73 11 73 11 73 81 0 64 -7 76 -29 50 -7 -8 -30 -17 -51 -21 -52 -9 -103 16
      -124 60 -20 42 -20 59 0 101 30 62 98 80 167 45 l37 -19 0 64 0 63 -37 10
      c-51 14 -100 13 -147 -4z"/>
      <path d="M8832 718 l3 -223 133 -3 132 -3 0 50 0 50 -72 3 -73 3 0 35 0 35 68
      3 67 3 0 49 0 50 -71 0 -70 0 3 33 3 32 73 3 72 3 0 49 0 50 -135 0 -135 0 2
      -222z"/>
      <path d="M9172 718 l3 -223 58 -3 57 -3 0 81 c0 44 3 80 8 79 4 0 30 -35 57
      -77 l50 -77 73 -3 c40 -2 72 1 72 7 0 5 -29 45 -65 89 l-65 81 34 20 c42 26
      70 90 61 138 -8 45 -49 90 -93 103 -20 5 -85 10 -145 10 l-107 0 2 -222z m177
      121 c29 -10 32 -15 29 -47 -2 -29 -8 -37 -31 -45 -44 -14 -57 -3 -57 46 0 61
      5 65 59 46z"/>
      <path d="M9737 924 c-63 -20 -132 -87 -147 -144 -27 -100 23 -213 114 -259 70
      -36 172 -36 242 0 120 61 159 218 80 321 -61 81 -184 116 -289 82z m173 -129
      c16 -15 32 -40 35 -55 14 -64 -52 -140 -120 -140 -68 0 -134 76 -120 140 6 27
      46 72 75 83 34 14 101 -1 130 -28z"/>
      <path d="M10352 719 l3 -224 85 -3 c162 -6 246 31 295 133 23 47 27 64 22 110
      -7 70 -46 129 -111 170 -47 28 -56 30 -173 34 l-123 3 2 -223z m228 93 c37
      -28 51 -61 47 -111 -3 -29 -13 -52 -29 -68 -25 -24 -101 -49 -119 -38 -11 7
      -12 228 -1 239 11 12 74 -2 102 -22z"/>
      <path d="M10812 718 l3 -223 130 0 130 0 3 48 3 47 -71 0 -71 0 3 38 3 37 63
      3 62 3 0 49 0 50 -65 0 -65 0 0 35 0 35 70 0 70 0 0 50 0 50 -135 0 -135 0 2
      -222z"/>
      <path d="M11152 718 l3 -223 130 0 130 0 3 47 3 47 -73 3 -73 3 -3 173 -2 172
      -60 0 -60 0 2 -222z"/>
      <path d="M11670 715 l0 -225 60 0 59 0 3 88 3 87 68 3 68 3 -3 47 -3 47 -67 3
      -68 3 0 34 0 35 75 0 75 0 0 50 0 50 -135 0 -135 0 0 -225z"/>
      <path d="M12010 772 c0 -159 1 -171 23 -203 65 -98 271 -101 341 -6 19 26 21
      45 24 203 l3 174 -60 0 -61 0 0 -148 c0 -177 -6 -192 -75 -192 -69 0 -76 18
      -78 192 l-2 143 -57 3 -58 3 0 -169z"/>
      <path d="M12444 926 c-3 -8 -4 -29 -2 -48 3 -32 5 -33 53 -38 l50 -5 5 -170 5
      -170 55 0 55 0 5 170 5 170 48 3 47 3 0 50 0 49 -160 0 c-129 0 -162 -3 -166
      -14z"/>
      <path d="M12814 925 c-3 -8 -4 -81 -2 -162 3 -127 6 -153 24 -183 42 -72 131
      -102 238 -80 118 24 136 62 136 279 l0 161 -60 0 -60 0 0 -142 c0 -176 -6
      -192 -72 -196 -73 -5 -82 17 -86 195 l-4 143 -54 0 c-39 0 -56 -4 -60 -15z"/>
      <path d="M13290 716 l0 -226 60 0 60 0 0 80 c0 44 3 80 8 80 4 -1 30 -36 58
      -78 l50 -77 72 -3 c47 -2 72 1 72 8 0 6 -29 46 -65 90 l-65 79 30 16 c57 30
      83 134 46 190 -34 51 -61 60 -198 64 l-128 3 0 -226z m184 122 c48 -21 41 -81
      -9 -94 -42 -10 -55 1 -55 49 0 60 13 69 64 45z"/>
      <path d="M13857 924 c-66 -20 -130 -85 -145 -147 -33 -131 45 -251 181 -278
      149 -30 277 57 294 200 8 66 -11 116 -62 167 -69 68 -166 89 -268 58z m173
      -129 c37 -35 45 -73 26 -119 -29 -69 -110 -95 -174 -56 -79 48 -71 164 13 201
      37 16 104 3 135 -26z"/>
    `,
    relevancia: 8
  },

  {
    id: 106,
    payed : true,
    nombre: "Fairis",
    enlace: "https://fairis.com/",
    categoria: "materiales",
    subcategoria: [],
    descripcion: "Con casi un siglo de presencia, inversión permanente en nuevas tecnologías y atención al cliente en todas las gamas de vidrio de alto desempeño.",
    svgContent: `
      <path d="M890 1585 l0 -1575 363 0 c302 1 365 3 381 15 16 12 55 15 183 15
      l163 0 325 325 325 325 1379 0 c1177 0 1380 -2 1390 -14 9 -10 12 -101 11
      -325 l0 -310 327 -4 c181 -3 344 -8 364 -12 27 -5 40 -3 53 10 15 15 16 57 11
      508 -3 271 -7 970 -10 1555 l-5 1062 -370 0 -370 0 0 -680 c0 -537 -3 -680
      -12 -680 -7 0 -320 307 -695 682 l-682 682 -1187 -1187 c-652 -653 -1190
      -1184 -1195 -1181 -14 8 -11 491 2 500 6 3 81 6 166 5 88 -1 160 2 166 8 9 7
      11 89 9 305 l-3 296 -172 2 -172 3 0 310 0 310 752 3 753 2 5 23 c3 12 4 150
      3 307 l-3 285 -1127 3 -1128 2 0 -1575z m3525 105 c206 -206 375 -378 375
      -382 0 -4 -344 -8 -765 -8 -477 0 -765 4 -765 10 0 17 751 761 765 758 8 -2
      184 -172 390 -378z"/>
      <path d="M6408 1603 c-4 -1053 -3 -1562 4 -1570 8 -10 93 -13 363 -13 195 0
      359 2 367 5 11 4 13 222 10 1259 -2 1135 -1 1256 14 1270 13 14 48 16 237 16
      140 0 234 -4 256 -12 142 -46 262 -150 326 -282 34 -71 39 -90 43 -175 5 -113
      -13 -179 -75 -269 -34 -49 -134 -138 -188 -168 -231 -126 -296 -187 -347 -329
      -33 -90 -14 -242 39 -330 14 -22 233 -248 486 -503 l462 -462 802 0 803 0 0
      130 c0 72 4 130 9 130 5 0 51 -22 103 -49 80 -42 139 -69 223 -101 133 -50
      319 -85 535 -100 124 -9 198 -8 371 4 118 8 235 19 260 25 24 5 76 14 114 21
      39 6 90 18 115 25 25 8 72 21 105 31 33 9 64 20 70 25 5 5 15 9 23 9 20 0 114
      43 205 94 231 128 400 343 456 579 15 66 14 236 -3 299 -67 247 -315 479 -666
      620 -14 6 -38 16 -55 23 -67 28 -319 98 -450 125 -33 6 -89 18 -125 25 -36 7
      -92 19 -125 25 -61 12 -145 33 -201 51 -17 5 -36 9 -42 9 -31 0 -185 85 -221
      121 -93 95 -106 218 -33 318 24 32 149 121 171 121 6 0 19 4 29 9 52 29 224
      61 323 61 182 0 334 -93 404 -248 14 -31 29 -64 34 -72 7 -13 68 -15 441 -18
      l432 -2 -5 22 c-25 104 -50 161 -112 258 -98 152 -237 270 -430 364 -71 35
      -150 69 -175 76 -25 6 -55 16 -66 20 -77 30 -289 67 -464 81 -200 16 -424 3
      -535 -31 -16 -5 -57 -16 -90 -25 -91 -25 -129 -38 -140 -47 -5 -4 -16 -8 -25
      -8 -8 0 -28 -7 -44 -15 -15 -8 -33 -15 -38 -15 -18 0 -233 -108 -286 -143 -97
      -66 -92 -73 -92 122 l0 171 -370 0 -370 0 -2 -1392 -3 -1393 -93 0 -92 0 -420
      420 c-231 231 -420 425 -420 431 0 7 21 25 48 40 226 132 418 384 486 639 51
      196 36 406 -44 590 -64 149 -186 293 -340 401 -107 75 -178 115 -275 154 -11
      4 -36 15 -57 24 -20 9 -43 16 -51 16 -9 0 -18 4 -21 9 -3 5 -18 11 -33 14 -16
      3 -59 15 -98 26 -68 20 -94 20 -756 21 l-686 0 -5 -1557z m3698 52 c55 -37
      244 -125 268 -125 8 0 17 -4 20 -9 3 -5 16 -11 28 -14 13 -3 61 -20 108 -37
      47 -18 99 -36 115 -40 17 -5 55 -16 85 -25 100 -29 264 -64 350 -75 220 -28
      391 -103 509 -221 88 -90 128 -175 114 -249 -12 -65 -123 -153 -248 -198 -139
      -49 -514 -61 -675 -21 -111 28 -202 93 -238 171 -36 79 -42 99 -42 143 l0 45
      -242 2 -243 3 -3 335 c-1 184 0 340 3 347 5 15 38 3 91 -32z"/>
      <path d="M12895 3146 c-94 -30 -159 -86 -200 -172 -34 -71 -36 -202 -4 -268
      29 -62 95 -129 159 -162 46 -23 67 -27 135 -27 96 0 151 21 221 85 153 140
      133 394 -40 502 -88 55 -182 70 -271 42z m153 -48 c26 -6 64 -22 85 -35 69
      -43 126 -148 127 -230 0 -85 -75 -200 -160 -243 -49 -25 -160 -27 -214 -5 -51
      22 -125 92 -147 140 -23 50 -25 158 -4 209 19 44 88 122 127 142 60 31 121 39
      186 22z"/>
      <path d="M12863 3014 c-10 -4 -13 -48 -13 -169 0 -136 3 -165 16 -176 29 -24
      49 1 50 65 0 62 10 79 45 74 17 -2 32 -20 57 -68 34 -67 71 -95 93 -73 8 8 4
      27 -17 70 -16 32 -30 61 -32 65 -2 4 7 18 21 30 13 13 29 40 36 60 16 48 -4
      91 -51 108 -36 13 -185 23 -205 14z m179 -81 c38 -39 -6 -73 -92 -73 -31 0
      -39 12 -34 50 1 14 3 31 3 39 1 21 98 9 123 -16z"/>
    `,
    relevancia: 8
  },

  {
    id: 107,
    payed : true,
    nombre: "FV",
    enlace: "https://fvandina.com/",
    categoria: "materiales",
    subcategoria: [],
    descripcion: "¡Descubre todo lo que en FV tenemos para ti!",
    svgContent: `
      <path d="M6935 3104 c-148 -24 -296 -80 -418 -157 -138 -88 -294 -269 -372
      -431 -89 -185 -115 -303 -115 -520 l0 -155 -281 -3 -281 -3 -29 -33 -29 -32 0
      -261 c0 -270 2 -288 44 -321 19 -16 50 -18 294 -18 l272 0 0 -517 c0 -579 -1
      -570 70 -606 31 -16 62 -17 287 -15 l253 3 32 33 33 32 3 525 3 525 128 0 129
      0 212 -512 c117 -282 221 -529 231 -549 29 -58 43 -60 357 -57 l282 3 24 25
      c35 37 710 1664 702 1694 -3 13 -14 34 -25 47 l-19 24 -305 3 -306 3 -29 -28
      c-22 -21 -68 -120 -183 -395 -84 -203 -154 -367 -156 -365 -1 2 -72 170 -158
      373 -108 257 -163 376 -180 392 -26 22 -28 22 -367 22 l-340 0 4 143 c4 126 8
      149 32 208 40 97 108 177 186 217 63 33 68 34 165 30 91 -3 106 -7 163 -38 64
      -34 111 -80 160 -157 47 -74 50 -75 364 -71 276 3 276 3 302 27 40 38 50 79
      31 137 -30 92 -123 270 -183 350 -203 273 -485 420 -822 429 -74 2 -148 1
      -165 -1z"/>
    `,
    relevancia: 8
  },

  // DISTRIBUIDORAS    
  {
    id: 200,
    payed : true,
    nombre: "Kiwi",
    enlace: "https://www.kywi.com.ec/",
    categoria: "distribuidoras",
    subcategoria: [],
    descripcion: "Comercial Kywi S.A. es una empresa líder en la comercialización de productos de ferretería, hogar y construcción en el mercado ecuatoriano.",
    svgContent: `
      <path d="M3031 3160 c-71 -26 -151 -87 -190 -147 -64 -97 -62 -46 -59 -1179
      l3 -1029 27 -57 c37 -79 105 -148 185 -189 l67 -34 624 -3 c677 -3 684 -3 771
      52 63 40 136 129 162 198 l24 63 0 1025 0 1025 -23 57 c-33 81 -108 160 -190
      200 l-67 33 -640 2 c-612 2 -642 2 -694 -17z"/>
      <path d="M5394 3170 c-28 -11 -82 -75 -90 -106 -4 -14 -4 -46 -1 -71 4 -40 13
      -54 79 -122 l75 -76 -329 -319 -328 -319 0 -336 0 -337 400 -313 c220 -172
      400 -316 400 -320 0 -4 -13 -20 -30 -36 -66 -63 -79 -152 -34 -222 48 -73 47
      -73 474 -73 426 0 428 0 475 72 l25 38 0 411 c0 398 -1 413 -21 445 -30 49
      -77 74 -138 74 -29 0 -62 -5 -74 -11 -12 -6 -58 -48 -102 -95 l-80 -84 -241
      187 c-132 104 -271 211 -307 238 -37 28 -66 52 -66 55 0 3 105 113 233 244
      l233 239 82 -71 c109 -94 170 -106 248 -46 64 48 63 44 63 464 0 427 0 429
      -69 476 l-36 24 -410 -1 c-225 0 -419 -4 -431 -9z"/>
      <path d="M10960 3033 l-45 -138 -147 -3 c-82 -1 -148 -6 -148 -10 1 -4 46 -38
      101 -77 148 -103 140 -81 87 -243 -25 -75 -44 -139 -42 -141 2 -2 53 33 113
      78 61 45 117 84 125 87 8 3 63 -30 131 -81 64 -47 119 -85 120 -83 2 2 -16 64
      -41 138 -24 74 -42 140 -40 146 2 6 57 49 121 95 l117 84 -153 5 -153 5 -44
      138 c-25 75 -48 137 -51 137 -4 0 -27 -62 -51 -137z"/>
      <path d="M6755 2316 c-66 -29 -124 -116 -125 -187 0 -20 48 -216 106 -435 59
      -220 112 -421 119 -449 7 -27 27 -102 44 -165 138 -517 178 -676 174 -682 -2
      -5 -937 -8 -2076 -8 -2002 0 -2073 -1 -2113 -19 -118 -53 -140 -217 -42 -308
      60 -57 -100 -53 2335 -53 1489 0 2250 4 2275 10 57 16 92 65 126 177 98 320
      178 583 232 763 34 113 82 268 106 345 23 77 79 262 124 410 45 149 88 289 96
      313 20 61 18 145 -6 191 -40 79 -112 116 -210 109 -67 -5 -124 -38 -154 -89
      -10 -17 -103 -302 -206 -632 -103 -330 -190 -595 -193 -590 -3 5 -41 135 -83
      289 -255 930 -249 910 -279 949 -15 21 -46 46 -69 56 -48 22 -137 24 -181 5z"/>
      <path d="M8384 2305 c-108 -54 -138 -152 -91 -300 62 -196 455 -1353 469
      -1380 60 -114 231 -141 326 -52 35 33 49 63 222 495 88 218 164 398 169 400 5
      2 12 -10 15 -25 4 -15 40 -131 81 -258 40 -126 97 -304 126 -394 57 -179 81
      -219 154 -252 97 -44 225 -6 270 81 7 14 54 133 105 265 50 132 102 267 115
      300 12 33 34 89 48 125 58 152 78 204 101 263 137 349 196 513 196 546 0 56
      -47 140 -98 176 -38 26 -52 30 -111 30 -58 0 -74 -4 -115 -30 -62 -39 -74 -63
      -197 -385 -55 -146 -120 -314 -144 -375 -23 -60 -46 -120 -49 -132 -10 -31
      -22 -29 -30 5 -7 29 -71 233 -188 597 -66 205 -73 223 -112 261 -58 59 -127
      76 -211 53 -78 -22 -112 -72 -200 -294 -212 -540 -273 -687 -277 -679 -3 5
      -69 203 -148 439 -86 261 -151 442 -166 462 -36 47 -87 74 -152 80 -48 4 -65
      0 -108 -22z"/>
      <path d="M10940 2324 c-37 -15 -91 -59 -112 -93 l-23 -36 -3 -745 c-2 -520 0
      -756 8 -783 47 -162 276 -198 375 -58 l30 43 3 761 2 762 -24 45 c-13 25 -42
      58 -65 75 -35 24 -53 30 -109 32 -37 1 -74 0 -82 -3z"/>
      <path d="M7882 373 c-73 -36 -120 -125 -107 -205 8 -48 58 -115 105 -139 33
      -18 96 -19 1614 -19 l1580 0 44 21 c137 67 137 270 0 340 -36 18 -86 19 -1620
      19 -1434 0 -1586 -2 -1616 -17z"/>
    `,
    relevancia: 6
  },

  // BANCOS


  // UNIVERSIDADES
  
  // CREADOR
  {
    id: 500,
    payed : true,
    nombre: "Constructores Positivos",
    enlace: "https://www.constructorespositivos.com",
    categoria: "creador",
    subcategoria: [],
    descripcion: "Cluster de Constructores del Ecuador",
    svgContent: `
       <path d="M170 2989 c-68 -31 -107 -65 -140 -122 l-30 -52 0 -252 c0 -175 4
        -261 12 -280 56 -129 165 -193 332 -193 146 0 257 57 309 159 35 70 34 87 -4
        106 -39 21 -56 14 -74 -29 -22 -52 -64 -96 -113 -117 -51 -22 -161 -25 -224
        -6 -53 15 -114 74 -127 124 -16 57 -13 419 3 466 30 84 107 127 228 127 119 0
        201 -47 230 -132 13 -36 49 -46 83 -24 31 20 31 28 1 92 -26 55 -76 103 -143
        134 -63 29 -277 29 -343 -1z"/>
        <path d="M915 2986 c-63 -29 -111 -77 -141 -141 -23 -48 -24 -58 -24 -290 0
        -231 1 -242 24 -290 52 -112 170 -175 327 -175 116 0 197 30 260 97 77 80 89
        146 79 423 -6 165 -10 202 -27 240 -25 56 -72 101 -139 134 -48 24 -62 26
        -180 25 -112 0 -135 -3 -179 -23z m291 -82 c49 -20 81 -49 105 -95 16 -32 19
        -65 21 -255 3 -240 2 -249 -59 -306 -44 -42 -93 -58 -181 -58 -91 0 -135 15
        -181 61 -56 56 -61 81 -61 304 0 218 5 245 54 298 42 46 101 67 187 67 48 0
        91 -6 115 -16z"/>
        <path d="M2418 2991 c-61 -31 -98 -61 -126 -105 -23 -36 -27 -51 -27 -128 0
        -80 2 -89 30 -130 47 -67 144 -107 305 -123 181 -19 244 -71 225 -186 -9 -51
        -56 -99 -113 -116 -23 -7 -75 -13 -116 -13 -114 0 -174 34 -245 138 -13 18
        -31 32 -42 32 -32 0 -59 -19 -59 -41 0 -51 78 -152 145 -187 142 -73 378 -49
        471 50 39 41 48 59 64 125 24 104 -24 212 -114 253 -47 21 -101 33 -239 55
        -158 24 -207 61 -207 154 0 65 31 102 108 131 119 45 252 11 322 -83 36 -49
        61 -58 101 -37 36 20 19 68 -55 149 -17 18 -53 44 -81 57 -45 21 -64 24 -180
        24 -106 -1 -137 -4 -167 -19z"/>
        <path d="M5255 2976 c-34 -18 -74 -51 -92 -75 -54 -70 -63 -119 -63 -353 0
        -181 2 -214 19 -258 53 -140 173 -206 357 -198 151 6 250 68 300 187 8 18 14
        40 14 47 0 15 -67 47 -81 38 -5 -3 -20 -27 -34 -54 -42 -83 -113 -120 -228
        -120 -84 0 -163 32 -202 84 -24 32 -28 48 -36 148 -9 119 -3 299 12 359 22 88
        106 139 229 139 120 0 180 -35 229 -133 19 -39 57 -47 91 -19 22 18 23 21 10
        53 -36 89 -97 150 -179 177 -19 7 -90 12 -160 12 -124 0 -127 -1 -186 -34z"/>
        <path d="M6594 2986 c-63 -30 -113 -78 -145 -142 -23 -48 -24 -56 -23 -279 0
        -165 4 -241 14 -270 44 -132 161 -205 333 -205 173 0 304 87 336 223 14 62 14
        428 0 482 -25 94 -66 145 -155 189 -48 24 -62 26 -180 26 -115 0 -135 -3 -180
        -24z m302 -85 c54 -25 101 -83 114 -143 12 -56 12 -232 1 -361 -7 -76 -12 -92
        -38 -125 -52 -64 -94 -82 -198 -82 -113 1 -164 23 -212 94 l-33 48 0 213 c0
        262 9 292 110 349 39 22 57 26 130 26 61 0 96 -6 126 -19z"/>
        <path d="M8715 2986 c-60 -28 -111 -77 -131 -124 -18 -44 -18 -160 0 -203 37
        -88 116 -125 324 -154 116 -15 190 -46 210 -85 8 -15 11 -48 9 -83 -4 -72 -36
        -110 -113 -132 -141 -41 -263 -6 -342 98 -44 58 -64 67 -103 47 -25 -14 -24
        -31 5 -88 55 -109 151 -164 296 -170 112 -5 211 19 276 66 78 57 115 191 79
        286 -35 92 -130 145 -285 161 -154 16 -232 46 -255 101 -33 80 -8 146 71 185
        126 61 290 22 355 -83 13 -21 29 -40 37 -43 17 -6 68 20 75 38 14 38 -71 141
        -152 182 -46 23 -61 25 -178 25 -114 0 -134 -3 -178 -24z"/>
        <path d="M1515 2988 c-3 -7 -4 -206 -3 -443 l3 -430 45 0 45 0 0 353 c0 193 2
        352 5 352 3 0 18 -24 34 -53 32 -57 406 -598 439 -634 25 -28 91 -32 101 -7 9
        24 7 847 -3 862 -5 8 -23 12 -47 10 l-39 -3 0 -353 c0 -193 -3 -352 -6 -352
        -4 0 -27 35 -52 78 -25 42 -133 201 -239 352 l-193 275 -43 3 c-28 2 -44 -1
        -47 -10z"/>
        <path d="M2912 2988 c-14 -14 -16 -47 -4 -65 5 -8 53 -15 138 -20 l129 -8 3
        -379 c1 -260 6 -383 13 -393 18 -20 76 -17 89 6 6 13 10 156 10 395 l0 376 93
        2 c140 2 151 3 165 11 18 12 15 74 -4 81 -9 3 -152 6 -318 6 -222 0 -305 -3
        -314 -12z"/>
        <path d="M3607 2994 c-4 -4 -7 -202 -7 -441 l0 -433 25 -10 c16 -6 34 -6 50 0
        l25 10 0 169 c0 123 3 171 13 179 8 6 54 7 130 2 110 -7 120 -9 147 -35 16
        -15 59 -87 96 -159 37 -72 74 -139 82 -148 17 -20 96 -25 107 -8 7 11 -133
        288 -171 337 -28 36 -29 43 -11 43 8 0 34 14 60 31 67 44 97 109 97 210 0 118
        -38 186 -127 230 -45 22 -61 24 -278 27 -127 2 -233 0 -238 -4z m463 -112 c70
        -38 96 -147 54 -227 -36 -68 -58 -75 -243 -76 -89 0 -166 3 -171 6 -11 7 -14
        298 -3 308 3 4 79 7 167 7 138 0 166 -3 196 -18z"/>
        <path d="M4324 2987 c-2 -8 -3 -164 -2 -348 l3 -335 30 -60 c52 -101 157 -154
        307 -154 154 0 247 54 314 180 17 32 19 66 22 368 3 249 1 337 -8 347 -15 18
        -71 20 -88 3 -9 -9 -12 -96 -12 -330 0 -298 -1 -321 -20 -357 -38 -75 -107
        -111 -214 -111 -86 0 -159 31 -193 82 -36 56 -43 124 -43 421 0 207 -3 286
        -12 295 -16 16 -77 15 -84 -1z"/>
        <path d="M5784 2986 c-3 -8 -4 -27 -2 -43 3 -26 7 -28 58 -35 30 -3 90 -6 133
        -7 l77 -1 1 -362 c1 -200 4 -376 8 -393 6 -28 9 -30 51 -30 l45 0 3 391 2 391
        132 6 c136 7 148 11 148 52 0 44 -9 45 -337 45 -261 0 -315 -2 -319 -14z"/>
        <path d="M7244 2992 c-20 -12 -26 -202 -18 -543 7 -322 7 -331 28 -338 11 -5
        32 -5 46 -1 l25 6 3 177 c1 97 6 177 10 177 4 0 41 2 82 4 87 5 152 -7 189
        -33 16 -12 52 -70 91 -148 90 -180 92 -183 145 -183 24 0 46 4 50 10 9 15
        -138 304 -177 347 l-20 22 43 21 c64 32 96 67 119 127 54 144 -12 304 -143
        347 -38 13 -92 16 -255 16 -114 0 -212 -4 -218 -8z m446 -110 c50 -25 75 -74
        75 -147 0 -47 -5 -67 -23 -93 -40 -55 -64 -62 -234 -62 -84 -1 -159 -1 -165
        -1 -10 1 -13 40 -13 161 l0 160 163 0 c134 0 168 -3 197 -18z"/>
        <path d="M7967 2993 c-11 -10 -8 -871 3 -878 18 -11 542 -6 556 6 17 14 18 65
        2 76 -7 4 -114 10 -238 13 l-225 5 0 145 0 145 193 3 193 2 9 26 c13 34 13 40
        -6 58 -13 13 -45 16 -200 16 -217 0 -196 -17 -192 165 l3 120 185 6 c102 4
        202 7 223 8 45 1 67 33 48 70 -11 21 -17 21 -280 21 -147 0 -271 -3 -274 -7z"/>
        <path d="M11540 2073 c-327 -60 -610 -299 -718 -608 -76 -217 -67 -480 23
        -673 14 -29 25 -55 25 -58 0 -18 103 -159 159 -217 181 -189 410 -287 671
        -287 435 0 805 297 905 727 24 104 22 317 -5 417 -50 187 -117 304 -250 436
        -138 137 -270 210 -460 255 -62 14 -287 19 -350 8z m672 -415 c40 -28 62 -75
        61 -130 -1 -50 -20 -89 -82 -164 -20 -23 -56 -70 -81 -104 -25 -34 -53 -70
        -64 -80 -10 -10 -35 -41 -55 -68 -93 -127 -139 -188 -181 -240 -25 -32 -63
        -82 -85 -112 -22 -30 -42 -57 -45 -60 -3 -3 -16 -19 -27 -36 -31 -44 -86 -60
        -151 -44 -48 11 -64 25 -241 203 -105 106 -198 202 -207 215 -14 20 -18 57
        -15 127 2 35 62 89 114 102 42 12 52 11 90 -7 25 -12 88 -65 148 -125 64 -64
        112 -105 124 -104 20 0 64 52 200 234 32 44 62 82 65 85 3 3 21 25 40 50 75
        98 178 226 196 241 61 52 138 59 196 17z"/>
        <path d="M3125 2059 c-123 -21 -166 -34 -255 -77 -74 -36 -109 -61 -165 -116
        -81 -80 -121 -146 -161 -261 l-28 -80 -1 -390 c0 -346 2 -397 18 -453 69 -244
        229 -398 484 -468 79 -22 108 -24 283 -24 235 0 293 11 445 88 118 59 208 147
        265 260 69 137 80 214 80 599 0 343 -6 397 -60 526 -90 214 -267 347 -525 393
        -87 15 -300 17 -380 3z m323 -475 c60 -30 108 -94 117 -158 4 -22 5 -174 3
        -336 -3 -321 -4 -323 -63 -383 -39 -38 -78 -55 -145 -63 -156 -17 -257 23
        -305 120 l-26 53 3 324 3 324 32 47 c51 72 112 98 233 98 83 0 103 -3 148 -26z"/>
        <path d="M4865 2060 c-212 -39 -314 -84 -419 -185 -117 -113 -156 -208 -156
        -385 0 -178 38 -281 140 -381 112 -110 262 -164 563 -205 120 -16 221 -43 263
        -70 46 -30 50 -109 8 -155 -31 -35 -111 -53 -224 -53 -164 1 -211 25 -313 157
        -15 20 -38 39 -51 43 -14 3 -70 -10 -142 -34 -172 -58 -206 -72 -236 -100 -39
        -35 -36 -78 8 -171 75 -155 226 -261 454 -317 81 -20 438 -19 525 1 286 67
        457 203 519 414 21 70 21 237 1 315 -38 144 -125 253 -256 318 -132 65 -173
        76 -474 123 -178 29 -236 54 -255 111 -10 28 -9 40 7 71 26 54 79 72 211 72
        91 1 110 -2 158 -25 38 -18 65 -40 84 -68 52 -74 69 -93 89 -99 19 -5 175 53
        303 112 119 54 130 83 76 191 -49 99 -155 201 -259 249 -83 38 -98 43 -194 62
        -68 14 -368 20 -430 9z"/>
        <path d="M13220 2055 c-277 -50 -439 -174 -531 -405 -19 -47 -19 -258 0 -325
        40 -141 125 -240 265 -309 88 -44 261 -96 319 -96 16 0 47 -4 70 -9 23 -5 84
        -17 136 -27 157 -28 196 -54 196 -129 0 -90 -72 -125 -259 -125 -151 0 -218
        29 -280 124 -54 80 -74 85 -193 46 -93 -30 -136 -47 -231 -92 -72 -34 -76 -80
        -15 -200 69 -136 228 -248 421 -297 71 -18 112 -21 288 -21 174 0 218 3 290
        21 254 62 405 178 482 368 19 46 22 73 22 194 0 158 -15 218 -75 312 -88 136
        -261 228 -495 264 -321 49 -375 63 -410 109 -42 52 -14 127 57 157 44 18 221
        20 272 3 55 -18 98 -54 138 -114 19 -29 44 -56 55 -60 21 -6 81 2 107 16 20
        10 83 37 176 75 107 44 135 68 135 116 0 47 -27 103 -86 181 -126 163 -339
        240 -658 237 -72 -1 -160 -7 -196 -14z"/>
        <path d="M883 2006 l-28 -24 0 -857 0 -857 28 -24 c28 -24 31 -24 227 -24 196
        0 199 0 227 24 l28 24 5 244 5 243 225 6 c268 8 323 18 450 85 64 34 157 124
        194 186 115 197 121 487 14 691 -45 86 -155 195 -238 235 -139 68 -175 72
        -667 72 l-442 0 -28 -24z m825 -453 c19 -9 46 -34 60 -56 22 -33 27 -51 26
        -102 -1 -79 -24 -122 -84 -153 -42 -21 -56 -22 -190 -20 l-145 3 -3 164 c-2
        120 1 167 10 178 11 13 34 14 153 9 94 -5 151 -13 173 -23z"/>
        <path d="M6062 2007 l-22 -24 0 -859 0 -859 26 -23 c26 -23 29 -23 236 -20
        l209 3 19 25 c19 24 20 53 20 876 l0 851 -25 27 -24 26 -209 0 c-206 0 -209 0
        -230 -23z"/>
        <path d="M6756 2004 l-26 -27 0 -171 c0 -153 2 -174 20 -196 l19 -25 218 -5
        218 -5 5 -645 c5 -591 6 -648 22 -672 23 -35 61 -40 280 -36 198 3 202 5 218
        74 5 21 10 316 10 655 0 553 2 617 16 623 9 3 104 6 213 6 l198 0 24 26 c23
        24 24 32 27 181 4 174 1 194 -30 223 -21 20 -32 20 -714 20 l-691 0 -27 -26z"/>
        <path d="M8449 2011 l-24 -19 -3 -857 -2 -856 29 -30 29 -29 202 0 202 0 29
        29 29 29 0 845 0 845 -26 31 -26 31 -208 0 c-190 0 -210 -2 -231 -19z"/>
        <path d="M9088 2020 c-32 -19 -30 -60 8 -165 20 -55 39 -111 44 -125 4 -14 36
        -104 70 -200 34 -96 70 -200 80 -230 10 -30 42 -120 70 -200 28 -80 60 -170
        70 -200 10 -30 46 -134 80 -230 34 -96 76 -218 95 -272 39 -113 46 -127 75
        -153 21 -19 37 -20 255 -20 l234 0 29 28 c17 16 32 39 35 50 4 20 87 259 146
        422 12 33 33 92 46 130 13 39 33 97 46 130 12 33 36 103 55 155 18 52 60 174
        94 270 34 96 70 200 80 230 10 30 39 113 64 185 25 71 46 138 46 147 0 10 -9
        27 -20 38 -19 19 -33 20 -235 20 -236 0 -262 -5 -288 -58 -14 -26 -33 -83 -55
        -167 -6 -22 -23 -80 -37 -130 -40 -143 -43 -154 -76 -270 -17 -60 -37 -135
        -45 -165 -8 -30 -25 -91 -38 -135 -30 -101 -42 -158 -57 -267 -12 -93 -29
        -118 -29 -44 0 54 -25 180 -60 306 -6 19 -46 166 -90 325 -135 490 -149 536
        -169 559 -37 42 -60 46 -288 46 -123 0 -225 -5 -235 -10z"/>
    `,
    relevancia: 3
  },
  
  {
    id: 501,
    payed : true,
    nombre: "Entorno",
    enlace: "https://www.tiktok.com/@entorno.vfx",
    categoria: "creador",
    subcategoria: [],
    descripcion: "Diseño de espacios arquitectónicos",
    svgContent: `
      <path d="M1345 3175 c-333 -53 -639 -210 -880 -451 -218 -219 -374 -505 -441
        -814 -27 -122 -27 -506 -1 -630 138 -646 646 -1141 1292 -1256 152 -27 424
        -25 573 4 469 94 856 371 1096 787 152 265 229 622 197 920 -25 227 -73 392
        -172 585 -238 464 -680 782 -1196 859 -95 15 -368 12 -468 -4z m395 -235 c224
        -27 414 -97 597 -219 306 -205 522 -547 579 -916 20 -133 15 -378 -11 -495
        -119 -540 -526 -944 -1065 -1056 -105 -22 -350 -25 -460 -5 -310 55 -610 232
        -805 474 -152 188 -245 390 -291 632 -22 118 -23 347 -1 471 82 461 384 841
        810 1021 200 84 436 118 647 93z"/>
        <path d="M1503 2833 c-13 -2 -23 -6 -23 -8 0 -1 -14 -63 -30 -136 -50 -216
        -179 -793 -211 -939 -16 -74 -33 -144 -37 -154 -7 -16 -60 47 -302 353 -161
        204 -296 371 -300 371 -3 0 -13 -13 -22 -28 l-17 -29 389 -492 c215 -270 390
        -496 390 -501 0 -6 -172 -10 -460 -10 -361 0 -460 -3 -460 -12 0 -7 3 -23 6
        -36 l6 -22 629 0 c346 0 629 -3 629 -7 0 -8 -27 -42 -366 -468 -109 -137 -200
        -252 -202 -255 -3 -7 59 -31 67 -25 4 2 180 222 391 489 212 266 386 484 387
        482 2 -1 48 -202 102 -445 55 -244 102 -445 105 -448 2 -2 18 3 36 12 23 12
        30 21 25 35 -4 11 -65 277 -136 592 -71 315 -132 581 -135 591 -3 9 -3 17 -1
        17 9 0 791 -380 815 -396 19 -13 23 -13 28 0 3 8 4 27 2 42 -3 27 -34 43 -560
        299 -307 148 -558 272 -557 275 0 3 59 33 132 68 73 34 264 126 425 205 l294
        142 -29 27 -28 26 -564 -274 c-310 -151 -566 -272 -569 -270 -4 5 5 48 128
        593 38 172 70 319 70 328 0 15 -6 16 -47 8z"/>
        <path d="M8605 2375 c-382 -71 -610 -365 -593 -764 15 -338 215 -586 543 -671
        158 -42 390 -25 539 40 289 124 459 438 416 773 -42 332 -263 564 -595 622
        -104 18 -214 18 -310 0z m274 -379 c59 -30 106 -82 140 -156 24 -50 26 -66 26
        -185 0 -127 -1 -132 -33 -197 -40 -82 -97 -133 -171 -155 -187 -54 -350 81
        -368 305 -10 131 23 248 92 330 67 80 215 108 314 58z"/>
        <path d="M13265 2376 c-384 -75 -610 -368 -592 -765 9 -205 69 -343 207 -482
        68 -69 102 -94 170 -128 124 -60 220 -82 365 -83 372 -1 642 192 736 527 29
        102 32 293 5 400 -62 255 -246 442 -506 515 -97 27 -287 35 -385 16z m274
        -380 c59 -30 106 -82 140 -156 24 -50 26 -66 26 -185 0 -127 -1 -132 -33 -197
        -40 -82 -97 -133 -171 -155 -215 -62 -390 125 -368 392 12 141 75 252 169 299
        72 36 168 36 237 2z"/>
        <path d="M4120 1655 l0 -705 495 0 495 0 0 155 0 155 -245 0 -245 0 0 135 0
        135 225 0 225 0 0 130 0 130 -225 0 -225 0 0 125 0 125 245 0 245 0 0 160 0
        160 -495 0 -495 0 0 -705z"/>
        <path d="M5340 1655 l0 -705 180 0 180 0 2 363 3 362 279 -362 280 -363 208 0
        208 0 0 705 0 705 -185 0 -185 0 -2 -376 -3 -377 -278 377 -278 376 -205 0
        -204 0 0 -705z"/>
        <path d="M6870 2200 l0 -160 145 0 145 0 0 -545 0 -545 240 0 240 0 0 545 0
        545 145 0 145 0 0 160 0 160 -530 0 -530 0 0 -160z"/>
        <path d="M9710 1656 l0 -706 225 0 225 0 0 266 0 265 47 -3 46 -3 36 -140 c42
        -162 66 -216 126 -283 80 -88 196 -133 350 -134 62 0 107 6 145 18 l55 19 0
        164 0 164 -85 1 c-65 1 -92 5 -117 20 -38 24 -76 91 -93 166 -6 30 -14 62 -16
        70 -2 10 15 25 52 44 76 40 149 114 182 183 24 52 27 70 27 163 0 93 -3 111
        -27 163 -31 67 -103 140 -174 179 -27 15 -90 39 -139 54 l-90 28 -387 4 -388
        4 0 -706z m733 370 c85 -41 92 -166 13 -216 -37 -23 -135 -40 -228 -40 l-68 0
        0 141 0 141 123 -4 c91 -3 132 -9 160 -22z"/>
        <path d="M11140 1655 l0 -705 180 0 180 0 2 362 3 362 279 -362 279 -362 209
        0 208 0 -2 703 -3 702 -182 3 -183 2 -2 -377 -3 -377 -278 377 -279 377 -204
        0 -204 0 0 -705z"/>
    `,
    relevancia: 1
  }
];